var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          title: "Crear documento",
          dense: true,
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          addPadding: true,
          scroll: _vm.scroll,
        },
      }),
      _vm.loadingDetail
        ? _c(
            "v-col",
            { staticClass: "mt-20 px-0", attrs: { cols: "12" } },
            [_c("SkeletonLoaderDocumentCreate")],
            1
          )
        : [
            !_vm.$helpers.hasSomePermission(["add_document"])
              ? _c("v-col", [_c("PermissionDenied")], 1)
              : _c(
                  "v-col",
                  {
                    staticClass: "mt-20 pa-0",
                    staticStyle: { "z-index": "0" },
                  },
                  [
                    _vm.$route.name === "DocumentsClone"
                      ? _c(
                          "v-col",
                          { staticClass: "px-0", attrs: { cols: "12" } },
                          [
                            _c(
                              "v-alert",
                              {
                                staticClass: "mb-n1",
                                attrs: {
                                  text: "",
                                  outlined: "",
                                  color: "var(--light-yellow-500)",
                                  rounded: "",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex pa-0" },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          color: "var(--light-yellow-500)",
                                        },
                                      },
                                      [_vm._v("mdi-file-remove")]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "ml-3 alert-description" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "body-1 font-weight-bold",
                                          },
                                          [_vm._v("Creación de documento")]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "d-block body-2" },
                                          [
                                            _vm._v(
                                              "Estás creando " +
                                                _vm._s(
                                                  _vm.documentParent ===
                                                    _vm.documents.document_type
                                                    ? "un"
                                                    : "una"
                                                ) +
                                                " "
                                            ),
                                            _vm.documentParent !==
                                            _vm.documents.document_type
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("lower")(
                                                          (
                                                            _vm.activeDocument ||
                                                            {}
                                                          ).name || ""
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            [
                                              "CL56",
                                              "CL61",
                                              "CL112",
                                              "CL111",
                                            ].includes(
                                              this.$route.query.document_type
                                            ) &&
                                            _vm.hiddenAction &&
                                            _vm.$route.query.action
                                              ? [
                                                  _vm._v(" que "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("lower")(
                                                            (
                                                              _vm.overrideType.find(
                                                                (item) =>
                                                                  item.id.toString() ===
                                                                  this.$route
                                                                    .query
                                                                    .action
                                                              ) || {}
                                                            ).name || ""
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : _vm._e(),
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.documentParent ===
                                                    _vm.documents.document_type
                                                    ? "documento"
                                                    : ""
                                                ) +
                                                " a partir de la "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      (
                                                        _vm.documentTypes.find(
                                                          (d) =>
                                                            d.id ===
                                                            _vm.documentParent
                                                        ) || {}
                                                      ).name
                                                    ) +
                                                    " N° " +
                                                    _vm._s(
                                                      _vm.clonedDocumentNumber
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-col",
                      { staticClass: "pb-8 px-0", attrs: { cols: "12" } },
                      [
                        _c(
                          "v-expansion-panels",
                          {
                            attrs: { accordion: false },
                            model: {
                              value: _vm.panelInf,
                              callback: function ($$v) {
                                _vm.panelInf = $$v
                              },
                              expression: "panelInf",
                            },
                          },
                          [
                            _c(
                              "v-expansion-panel",
                              [
                                _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "px-5 py-8" },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        attrs: {
                                          "no-gutters": "",
                                          align: "center",
                                        },
                                      },
                                      [
                                        _c("v-col", { staticClass: "pa-0" }, [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    size: "18",
                                                    color: "grey-700",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-information-outline"
                                                  ),
                                                ]
                                              ),
                                              _vm._v(
                                                "Información del documento"
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-expansion-panel-content",
                                  { staticClass: "px-7 pb-8" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pa-0 mt-n2",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _c(
                                          "v-list",
                                          { staticClass: "transparent pa-0" },
                                          [
                                            _c(
                                              "v-row",
                                              { attrs: { align: "center" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "pa-0 mx-2",
                                                    staticStyle: {
                                                      width: "273px !important",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "pa-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-content",
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              {
                                                                staticClass:
                                                                  "grey-500--text py-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Tipo de documento"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-list-item-subtitle",
                                                              [
                                                                _c(
                                                                  "v-autocomplete",
                                                                  {
                                                                    attrs: {
                                                                      error:
                                                                        _vm.$v
                                                                          .documents
                                                                          .document_type
                                                                          .$error,
                                                                      placeholder:
                                                                        "Selecciona un tipo de documento",
                                                                      items:
                                                                        _vm.currentDocumentList,
                                                                      "item-value":
                                                                        "id",
                                                                      "item-text":
                                                                        "name",
                                                                      "menu-props":
                                                                        {
                                                                          overflowY: true,
                                                                          transition:
                                                                            "slide-y-transition",
                                                                        },
                                                                      height:
                                                                        "40",
                                                                      "single-line":
                                                                        "",
                                                                      outlined:
                                                                        "",
                                                                      dense: "",
                                                                      "hide-details":
                                                                        "",
                                                                      "append-icon":
                                                                        "mdi-chevron-down",
                                                                      "search-input":
                                                                        _vm.searchQuery,
                                                                      filter:
                                                                        _vm.customFilter,
                                                                    },
                                                                    on: {
                                                                      "update:searchInput":
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.searchQuery =
                                                                            $event
                                                                        },
                                                                      "update:search-input":
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.searchQuery =
                                                                            $event
                                                                        },
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u([
                                                                        {
                                                                          key: "item",
                                                                          fn: function (
                                                                            data
                                                                          ) {
                                                                            return [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                {
                                                                                  staticClass:
                                                                                    "font-weight-regular",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      data
                                                                                        .item
                                                                                        .name
                                                                                    ) +
                                                                                      " (" +
                                                                                      _vm._s(
                                                                                        data.item.id.replace(
                                                                                          /^[A-Z]{2}/,
                                                                                          ""
                                                                                        )
                                                                                      ) +
                                                                                      ")"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                        {
                                                                          key: "selection",
                                                                          fn: function (
                                                                            data
                                                                          ) {
                                                                            return [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                {
                                                                                  staticClass:
                                                                                    "grey-500--text py-1",
                                                                                  staticStyle:
                                                                                    {
                                                                                      "min-width":
                                                                                        "220px !important",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      data
                                                                                        .item
                                                                                        .name
                                                                                    ) +
                                                                                      " (" +
                                                                                      _vm._s(
                                                                                        data.item.id.replace(
                                                                                          /^[A-Z]{2}/,
                                                                                          ""
                                                                                        )
                                                                                      ) +
                                                                                      ")"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ]),
                                                                    model: {
                                                                      value:
                                                                        _vm.$v
                                                                          .documents
                                                                          .document_type
                                                                          .$model,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm
                                                                              .$v
                                                                              .documents
                                                                              .document_type,
                                                                            "$model",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "$v.documents.document_type.$model",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "pa-0 mx-2",
                                                    staticStyle: {
                                                      width: "173px !important",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "pa-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-content",
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              {
                                                                staticClass:
                                                                  "grey-500--text py-1",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Fecha de emisión"
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-list-item-subtitle",
                                                              [
                                                                _c(
                                                                  "v-menu",
                                                                  {
                                                                    attrs: {
                                                                      "close-on-content-click": false,
                                                                      "offset-y":
                                                                        "",
                                                                      "nudge-bottom": 10,
                                                                      transition:
                                                                        "slide-y-transition",
                                                                      "max-width":
                                                                        "290",
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u([
                                                                        {
                                                                          key: "activator",
                                                                          fn: function ({
                                                                            on,
                                                                            attrs,
                                                                          }) {
                                                                            return [
                                                                              _c(
                                                                                "v-text-field",
                                                                                _vm._g(
                                                                                  _vm._b(
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          error:
                                                                                            _vm
                                                                                              .$v
                                                                                              .documents
                                                                                              .date
                                                                                              .$error,
                                                                                          "append-icon":
                                                                                            "mdi-calendar-blank",
                                                                                          placeholder:
                                                                                            "dd-mm-aaaa",
                                                                                          outlined:
                                                                                            "",
                                                                                          "single-line":
                                                                                            "",
                                                                                          dense:
                                                                                            "",
                                                                                          readonly:
                                                                                            "",
                                                                                          "hide-details":
                                                                                            "",
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            _vm
                                                                                              .$v
                                                                                              .documents
                                                                                              .date
                                                                                              .$model,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .$v
                                                                                                  .documents
                                                                                                  .date,
                                                                                                "$model",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "$v.documents.date.$model",
                                                                                        },
                                                                                    },
                                                                                    "v-text-field",
                                                                                    attrs,
                                                                                    false
                                                                                  ),
                                                                                  on
                                                                                )
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ]),
                                                                    model: {
                                                                      value:
                                                                        _vm.datePickerMenuDocumentsDate,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.datePickerMenuDocumentsDate =
                                                                            $$v
                                                                        },
                                                                      expression:
                                                                        "datePickerMenuDocumentsDate",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-date-picker",
                                                                      {
                                                                        attrs: {
                                                                          min: "2020-01-01",
                                                                          "no-title":
                                                                            "",
                                                                          "first-day-of-week": 1,
                                                                          type: "date",
                                                                          locale:
                                                                            "es",
                                                                          "max-width":
                                                                            "290",
                                                                          color:
                                                                            "grey-900",
                                                                        },
                                                                        on: {
                                                                          input:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              _vm.datePickerMenuDocumentsDate = false
                                                                            },
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .$v
                                                                              .documents
                                                                              .date
                                                                              .$model,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .$v
                                                                                  .documents
                                                                                  .date,
                                                                                "$model",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "$v.documents.date.$model",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-row",
                                                                          {
                                                                            staticClass:
                                                                              "mb-2 px-6",
                                                                            attrs:
                                                                              {
                                                                                align:
                                                                                  "center",
                                                                                justify:
                                                                                  "end",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                staticClass:
                                                                                  "body-1",
                                                                                attrs:
                                                                                  {
                                                                                    ripple: false,
                                                                                    text: "",
                                                                                    color:
                                                                                      "grey-900",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    () => {
                                                                                      _vm.documents.date =
                                                                                        null
                                                                                      _vm.datePickerMenuDocumentsDate = false
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Limpiar"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "v-spacer"
                                                                            ),
                                                                            _c(
                                                                              "v-btn",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    color:
                                                                                      "grey-900",
                                                                                  },
                                                                                on: {
                                                                                  click:
                                                                                    () => {
                                                                                      _vm.$v.documents.date.$model =
                                                                                        _vm.today
                                                                                      _vm.datePickerMenuDocumentsDate = false
                                                                                    },
                                                                                },
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Hoy"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm.documents.document_type !==
                                                "CL52"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pa-0 mx-2",
                                                        staticStyle: {
                                                          width:
                                                            "173px !important",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "grey-500--text py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Fecha de vencimiento"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _c(
                                                                      "v-menu",
                                                                      {
                                                                        attrs: {
                                                                          "close-on-content-click": false,
                                                                          "offset-y":
                                                                            "",
                                                                          "nudge-bottom": 10,
                                                                          transition:
                                                                            "slide-y-transition",
                                                                          "max-width":
                                                                            "280",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function ({
                                                                                  on,
                                                                                  attrs,
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "v-text-field",
                                                                                      _vm._g(
                                                                                        _vm._b(
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                placeholder:
                                                                                                  "dd-mm-aaaa",
                                                                                                "append-icon":
                                                                                                  "mdi-calendar-blank",
                                                                                                outlined:
                                                                                                  "",
                                                                                                "single-line":
                                                                                                  "",
                                                                                                dense:
                                                                                                  "",
                                                                                                readonly:
                                                                                                  "",
                                                                                                "hide-details":
                                                                                                  "",
                                                                                              },
                                                                                            model:
                                                                                              {
                                                                                                value:
                                                                                                  _vm
                                                                                                    .documents
                                                                                                    .due_date,
                                                                                                callback:
                                                                                                  function (
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      _vm.documents,
                                                                                                      "due_date",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                expression:
                                                                                                  "documents.due_date",
                                                                                              },
                                                                                          },
                                                                                          "v-text-field",
                                                                                          attrs,
                                                                                          false
                                                                                        ),
                                                                                        on
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            false,
                                                                            3964776912
                                                                          ),
                                                                        model: {
                                                                          value:
                                                                            _vm.datePickerMenuDocumentsDueDate,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.datePickerMenuDocumentsDueDate =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "datePickerMenuDocumentsDueDate",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-date-picker",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                min: "2020-01-01",
                                                                                "no-title":
                                                                                  "",
                                                                                "first-day-of-week": 1,
                                                                                type: "date",
                                                                                locale:
                                                                                  "es",
                                                                                "max-width":
                                                                                  "290",
                                                                                color:
                                                                                  "grey-900",
                                                                              },
                                                                            on: {
                                                                              input:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.datePickerMenuDocumentsDueDate = false
                                                                                },
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .documents
                                                                                    .due_date,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.documents,
                                                                                      "due_date",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "documents.due_date",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-row",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-2 px-6",
                                                                                attrs:
                                                                                  {
                                                                                    align:
                                                                                      "center",
                                                                                    justify:
                                                                                      "end",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-btn",
                                                                                  {
                                                                                    staticClass:
                                                                                      "body-1",
                                                                                    attrs:
                                                                                      {
                                                                                        ripple: false,
                                                                                        text: "",
                                                                                        color:
                                                                                          "grey-900",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        () => {
                                                                                          _vm.documents.due_date =
                                                                                            null
                                                                                          _vm.datePickerMenuDocumentsDueDate = false
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Limpiar"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "v-spacer"
                                                                                ),
                                                                                _c(
                                                                                  "v-btn",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        color:
                                                                                          "grey-900",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        () => {
                                                                                          _vm.documents.due_date =
                                                                                            _vm.today
                                                                                          _vm.datePickerMenuDocumentsDueDate = false
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Hoy"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.$store?.state?.auth?.account
                                                  .country === "CL"
                                                  ? _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "pa-0 mx-2",
                                                        staticStyle: {
                                                          "min-width":
                                                            "200px !important",
                                                          "max-width":
                                                            "230px !important",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "grey-500--text py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "generals.Folio"
                                                                        )
                                                                      ) +
                                                                        " manual"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "d-flex align-center",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-switch",
                                                                          {
                                                                            staticClass:
                                                                              "ma-0",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "green-500",
                                                                                dense:
                                                                                  "",
                                                                                "hide-details":
                                                                                  "",
                                                                                ripple: false,
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .documents
                                                                                    .numbering,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.documents,
                                                                                      "numbering",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "documents.numbering",
                                                                              },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .number
                                                                                    .$error,
                                                                                placeholder:
                                                                                  "Ingresa el N° de folio",
                                                                                disabled:
                                                                                  !_vm
                                                                                    .documents
                                                                                    .numbering,
                                                                                oninput:
                                                                                  "this.value=this.value.replace(/[^0-9]/g,'').replace(/^0+/,'')",
                                                                                outlined:
                                                                                  "",
                                                                                "single-line":
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                "hide-details":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .number
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .number,
                                                                                      "$model",
                                                                                      typeof $$v ===
                                                                                        "string"
                                                                                        ? $$v.trim()
                                                                                        : $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.documents.number.$model",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                !["CL41", "CL39"].includes(
                                                  _vm.documents.document_type
                                                )
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pa-0 mt-n6 d-flex ml-2",
                                                        staticStyle: {
                                                          width:
                                                            "280px !important",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass:
                                                              "pa-0 ma-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "d-flex align-center grey-500--text py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Forma de pago"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  {
                                                                    staticClass:
                                                                      "mt-4",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-radio-group",
                                                                      {
                                                                        staticClass:
                                                                          "mt-n2 payment-radio pa-0",
                                                                        staticStyle:
                                                                          {
                                                                            position:
                                                                              "absolute",
                                                                          },
                                                                        attrs: {
                                                                          row: "",
                                                                          absolute:
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .documents
                                                                              .collection_method,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.documents,
                                                                                "collection_method",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "documents.collection_method",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-radio",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                label:
                                                                                  "Crédito",
                                                                                value: 2,
                                                                              },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "v-radio",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                label:
                                                                                  "Contado",
                                                                                value: 1,
                                                                              },
                                                                          }
                                                                        ),
                                                                        _c(
                                                                          "v-radio",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                label:
                                                                                  "Sin costo",
                                                                                value: 3,
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.showIndicator
                                                  ? _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "pa-0 mx-2",
                                                        staticStyle: {
                                                          "min-width":
                                                            "130px !important",
                                                        },
                                                        attrs: {
                                                          cols: _vm.$store
                                                            ?.state?.auth
                                                            ?.account
                                                            ?.allowed_to_assign
                                                            ? 2
                                                            : "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              {
                                                                staticClass:
                                                                  "py-1",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "grey-500--text d-flex align-center py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Indicador de servicio"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _c(
                                                                      "v-autocomplete",
                                                                      {
                                                                        attrs: {
                                                                          items:
                                                                            _vm.ticketIndicatorList,
                                                                          "item-value":
                                                                            "value",
                                                                          "item-text":
                                                                            "label",
                                                                          "menu-props":
                                                                            {
                                                                              overflowY: true,
                                                                              transition:
                                                                                "slide-y-transition",
                                                                              maxWidth: `${
                                                                                _vm
                                                                                  .$store
                                                                                  ?.state
                                                                                  ?.auth
                                                                                  ?.account
                                                                                  ?.country ===
                                                                                "PE"
                                                                                  ? "300px"
                                                                                  : "380px"
                                                                              }`,
                                                                            },
                                                                          label:
                                                                            "Selecciona el indicador de servicio",
                                                                          height:
                                                                            "40",
                                                                          "single-line":
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                          "append-icon":
                                                                            "mdi-chevron-down",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "selection",
                                                                                fn: function (
                                                                                  data
                                                                                ) {
                                                                                  return [
                                                                                    _c(
                                                                                      "v-list-item-title",
                                                                                      {
                                                                                        staticClass:
                                                                                          "grey-500--text py-1",
                                                                                        staticStyle:
                                                                                          {
                                                                                            "min-width":
                                                                                              "93% !important",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            data
                                                                                              .item
                                                                                              .label
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            false,
                                                                            3511025895
                                                                          ),
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .documents
                                                                              .service_type,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.documents,
                                                                                "service_type",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "documents.service_type",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.$helpers.hasSomePermission([
                                                  "view_branch",
                                                ]) && _vm.branchList?.length
                                                  ? _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "pa-0 mx-2",
                                                        staticStyle: {
                                                          "min-width":
                                                            "130px !important",
                                                        },
                                                        attrs: {
                                                          cols: _vm.$store
                                                            ?.state?.auth
                                                            ?.account
                                                            ?.allowed_to_assign
                                                            ? 2
                                                            : "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              {
                                                                staticClass:
                                                                  "py-1",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "grey-500--text d-flex align-center py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Tienda"
                                                                    ),
                                                                    _c(
                                                                      "v-chip",
                                                                      {
                                                                        staticClass:
                                                                          "ml-1 pa-2 caption grey-700--text",
                                                                        attrs: {
                                                                          "x-small":
                                                                            "",
                                                                          color:
                                                                            "grey-background",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Opcional"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _c(
                                                                      "v-autocomplete",
                                                                      {
                                                                        attrs: {
                                                                          label:
                                                                            "Selecciona una tienda",
                                                                          items:
                                                                            _vm.branchList,
                                                                          "item-value":
                                                                            "branch_id",
                                                                          "item-text":
                                                                            "name",
                                                                          "menu-props":
                                                                            {
                                                                              overflowY: true,
                                                                              transition:
                                                                                "slide-y-transition",
                                                                              maxWidth:
                                                                                "300px",
                                                                            },
                                                                          height:
                                                                            "40",
                                                                          "single-line":
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                          "append-icon":
                                                                            "mdi-chevron-down",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "item",
                                                                                fn: function (
                                                                                  data
                                                                                ) {
                                                                                  return [
                                                                                    _c(
                                                                                      "v-list-item-title",
                                                                                      {
                                                                                        staticClass:
                                                                                          "font-weight-regular",
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            data
                                                                                              .item
                                                                                              .name
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ],
                                                                            null,
                                                                            false,
                                                                            245714575
                                                                          ),
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .documents
                                                                              .issuer
                                                                              .branch,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .documents
                                                                                  .issuer,
                                                                                "branch",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "documents.issuer.branch",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "v-col",
                                                  {
                                                    staticClass: "pa-0 mx-2",
                                                    staticStyle: {
                                                      "min-width":
                                                        "400px !important",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item",
                                                      { staticClass: "pa-0" },
                                                      [
                                                        _c(
                                                          "v-list-item-content",
                                                          {
                                                            staticClass: "py-1",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              {
                                                                staticClass:
                                                                  "grey-500--text py-1",
                                                              },
                                                              [_vm._v("Glosa")]
                                                            ),
                                                            _c(
                                                              "v-list-item-subtitle",
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      oninput:
                                                                        "this.value=this.value.replace(/[^a-zA-Z0-9,. ]/g,'');",
                                                                      outlined:
                                                                        "",
                                                                      "single-line":
                                                                        "",
                                                                      dense: "",
                                                                      maxlength:
                                                                        "100",
                                                                      "hide-details":
                                                                        "",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .documents
                                                                          .note,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.documents,
                                                                            "note",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "documents.note",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-list-item",
                                                  {
                                                    staticClass: "pa-0 ml-2",
                                                    staticStyle: {
                                                      "max-width":
                                                        "370px !important",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-list-item-content",
                                                      { staticClass: "py-1" },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "d-flex align-center grey-500--text py-1",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Periodo de emisión"
                                                            ),
                                                            _c(
                                                              "v-chip",
                                                              {
                                                                staticClass:
                                                                  "ml-1 caption grey-700--text",
                                                                attrs: {
                                                                  "x-small": "",
                                                                  color:
                                                                    "grey-background",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Opcional"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          [
                                                            _c(
                                                              "v-row",
                                                              {
                                                                staticClass:
                                                                  "ma-0 pa-0",
                                                                attrs: {
                                                                  "no-gutters":
                                                                    "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "mr-2",
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "173px !important",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-menu",
                                                                      {
                                                                        attrs: {
                                                                          "close-on-content-click": false,
                                                                          "offset-y":
                                                                            "",
                                                                          transition:
                                                                            "slide-y-transition",
                                                                          "max-width":
                                                                            "290",
                                                                          "z-index":
                                                                            "1000",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function ({
                                                                                  on,
                                                                                  attrs,
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "v-text-field",
                                                                                      _vm._g(
                                                                                        _vm._b(
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                error:
                                                                                                  _vm
                                                                                                    .$v
                                                                                                    .documents
                                                                                                    .period_end
                                                                                                    .$error,
                                                                                                "append-icon":
                                                                                                  "mdi-calendar-blank",
                                                                                                placeholder:
                                                                                                  "dd-mm-aaaa",
                                                                                                prefix:
                                                                                                  "desde",
                                                                                                outlined:
                                                                                                  "",
                                                                                                "single-line":
                                                                                                  "",
                                                                                                dense:
                                                                                                  "",
                                                                                                readonly:
                                                                                                  "",
                                                                                                "hide-details":
                                                                                                  "",
                                                                                              },
                                                                                            model:
                                                                                              {
                                                                                                value:
                                                                                                  _vm
                                                                                                    .$v
                                                                                                    .documents
                                                                                                    .period_start
                                                                                                    .$model,
                                                                                                callback:
                                                                                                  function (
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      _vm
                                                                                                        .$v
                                                                                                        .documents
                                                                                                        .period_start,
                                                                                                      "$model",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                expression:
                                                                                                  "$v.documents.period_start.$model",
                                                                                              },
                                                                                          },
                                                                                          "v-text-field",
                                                                                          attrs,
                                                                                          false
                                                                                        ),
                                                                                        on
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ]
                                                                          ),
                                                                        model: {
                                                                          value:
                                                                            _vm.datePickerMenuDocumentsPeriodStart,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.datePickerMenuDocumentsPeriodStart =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "datePickerMenuDocumentsPeriodStart",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-date-picker",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .period_end
                                                                                    .$error,
                                                                                "no-title":
                                                                                  "",
                                                                                "first-day-of-week": 1,
                                                                                type: "date",
                                                                                locale:
                                                                                  "es",
                                                                                width:
                                                                                  "290",
                                                                                color:
                                                                                  "grey-900",
                                                                              },
                                                                            on: {
                                                                              input:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.datePickerMenuDocumentsPeriodStart = false
                                                                                },
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .period_start
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .period_start,
                                                                                      "$model",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.documents.period_start.$model",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-row",
                                                                              {
                                                                                staticClass:
                                                                                  "pt-0 pb-5 px-6",
                                                                                attrs:
                                                                                  {
                                                                                    align:
                                                                                      "center",
                                                                                    justify:
                                                                                      "end",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-btn",
                                                                                  {
                                                                                    staticClass:
                                                                                      "body-1",
                                                                                    attrs:
                                                                                      {
                                                                                        ripple: false,
                                                                                        text: "",
                                                                                        color:
                                                                                          "grey-900",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        () => {
                                                                                          _vm.$v.documents.period_start.$model =
                                                                                            null
                                                                                          _vm.datePickerMenuDocumentsPeriodStart = false
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Limpiar"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "v-spacer"
                                                                                ),
                                                                                _c(
                                                                                  "v-btn",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        color:
                                                                                          "grey-900",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        () => {
                                                                                          _vm.$v.documents.period_start.$model =
                                                                                            _vm.today
                                                                                          _vm.datePickerMenuDocumentsPeriodStart = false
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Hoy"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "mx-2",
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "173px !important",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-menu",
                                                                      {
                                                                        attrs: {
                                                                          "close-on-content-click": false,
                                                                          "offset-y":
                                                                            "",
                                                                          transition:
                                                                            "slide-y-transition",
                                                                          "max-width":
                                                                            "290",
                                                                          "z-index":
                                                                            "1000",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function ({
                                                                                  on,
                                                                                  attrs,
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "v-text-field",
                                                                                      _vm._g(
                                                                                        _vm._b(
                                                                                          {
                                                                                            staticClass:
                                                                                              "pa-0",
                                                                                            attrs:
                                                                                              {
                                                                                                error:
                                                                                                  _vm
                                                                                                    .$v
                                                                                                    .documents
                                                                                                    .period_start
                                                                                                    .$error,
                                                                                                "append-icon":
                                                                                                  "mdi-calendar-blank",
                                                                                                placeholder:
                                                                                                  "dd-mm-aaaa",
                                                                                                prefix:
                                                                                                  "hasta",
                                                                                                outlined:
                                                                                                  "",
                                                                                                "single-line":
                                                                                                  "",
                                                                                                dense:
                                                                                                  "",
                                                                                                readonly:
                                                                                                  "",
                                                                                                "hide-details":
                                                                                                  "",
                                                                                              },
                                                                                            model:
                                                                                              {
                                                                                                value:
                                                                                                  _vm
                                                                                                    .$v
                                                                                                    .documents
                                                                                                    .period_end
                                                                                                    .$model,
                                                                                                callback:
                                                                                                  function (
                                                                                                    $$v
                                                                                                  ) {
                                                                                                    _vm.$set(
                                                                                                      _vm
                                                                                                        .$v
                                                                                                        .documents
                                                                                                        .period_end,
                                                                                                      "$model",
                                                                                                      $$v
                                                                                                    )
                                                                                                  },
                                                                                                expression:
                                                                                                  "$v.documents.period_end.$model",
                                                                                              },
                                                                                          },
                                                                                          "v-text-field",
                                                                                          attrs,
                                                                                          false
                                                                                        ),
                                                                                        on
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ]
                                                                          ),
                                                                        model: {
                                                                          value:
                                                                            _vm.datePickerMenuDocumentsPeriodEnd,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.datePickerMenuDocumentsPeriodEnd =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "datePickerMenuDocumentsPeriodEnd",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-date-picker",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                "no-title":
                                                                                  "",
                                                                                "first-day-of-week": 1,
                                                                                type: "date",
                                                                                locale:
                                                                                  "es",
                                                                                width:
                                                                                  "290",
                                                                                color:
                                                                                  "grey-900",
                                                                                min: _vm
                                                                                  .documents
                                                                                  .period_start,
                                                                              },
                                                                            on: {
                                                                              input:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.datePickerMenuDocumentsPeriodEnd = false
                                                                                },
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .period_end
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .period_end,
                                                                                      "$model",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.documents.period_end.$model",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-row",
                                                                              {
                                                                                staticClass:
                                                                                  "pt-0 pb-5 px-6",
                                                                                attrs:
                                                                                  {
                                                                                    align:
                                                                                      "center",
                                                                                    justify:
                                                                                      "end",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-btn",
                                                                                  {
                                                                                    staticClass:
                                                                                      "body-1",
                                                                                    attrs:
                                                                                      {
                                                                                        ripple: false,
                                                                                        text: "",
                                                                                        color:
                                                                                          "grey-900",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        () => {
                                                                                          _vm.$v.documents.period_end.$model =
                                                                                            null
                                                                                          _vm.datePickerMenuDocumentsPeriodEnd = false
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Limpiar"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "v-spacer"
                                                                                ),
                                                                                _c(
                                                                                  "v-btn",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        color:
                                                                                          "grey-900",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        () => {
                                                                                          _vm.$v.documents.period_end.$model =
                                                                                            _vm.today
                                                                                          _vm.datePickerMenuDocumentsPeriodEnd = false
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Hoy"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-expansion-panels",
                          {
                            staticClass: "mt-5",
                            model: {
                              value: _vm.panelReceiver,
                              callback: function ($$v) {
                                _vm.panelReceiver = $$v
                              },
                              expression: "panelReceiver",
                            },
                          },
                          [
                            _c(
                              "v-expansion-panel",
                              [
                                _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "px-5 py-8" },
                                  [
                                    _c(
                                      "v-row",
                                      { attrs: { align: "center" } },
                                      [
                                        _c(
                                          "v-col",
                                          { staticClass: "pa-0 pl-3" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      size: "18",
                                                      color: "grey-700",
                                                    },
                                                  },
                                                  [_vm._v("mdi-account ")]
                                                ),
                                                _vm._v(
                                                  "Información del receptor"
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _c("v-spacer"),
                                        _c("v-row", {
                                          staticClass: "pr-5",
                                          attrs: {
                                            align: "center",
                                            justify: "end",
                                            "no-gutters": "",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-expansion-panel-content",
                                  { staticClass: "px-10 pb-10" },
                                  [
                                    _c(
                                      "v-row",
                                      { staticClass: "mt-n2" },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pa-0",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _c(
                                              "v-list",
                                              {
                                                staticClass: "transparent pa-0",
                                              },
                                              [
                                                _c(
                                                  "v-row",
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "pa-0 mx-2",
                                                        attrs: { cols: "2" },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "grey-500--text py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "generals.RUT"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _c(
                                                                      "v-menu",
                                                                      {
                                                                        attrs: {
                                                                          "close-on-content-click": false,
                                                                          "close-on-back": false,
                                                                          "max-width":
                                                                            "400px",
                                                                          "offset-y":
                                                                            "",
                                                                          bottom:
                                                                            "",
                                                                        },
                                                                        scopedSlots:
                                                                          _vm._u(
                                                                            [
                                                                              {
                                                                                key: "activator",
                                                                                fn: function ({
                                                                                  on,
                                                                                  attrs,
                                                                                }) {
                                                                                  return [
                                                                                    _c(
                                                                                      "v-text-field",
                                                                                      _vm._g(
                                                                                        _vm._b(
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                value:
                                                                                                  _vm.formattedTaxpayer,
                                                                                                error:
                                                                                                  _vm
                                                                                                    .$v
                                                                                                    .documents
                                                                                                    .customer
                                                                                                    .taxpayer
                                                                                                    .$error,
                                                                                                loading:
                                                                                                  _vm.customerLoading
                                                                                                    ? "green-500"
                                                                                                    : false,
                                                                                                placeholder:
                                                                                                  "Ej: 9605009-7",
                                                                                                outlined:
                                                                                                  "",
                                                                                                "single-line":
                                                                                                  "",
                                                                                                dense:
                                                                                                  "",
                                                                                                "hide-details":
                                                                                                  "",
                                                                                                maxlength:
                                                                                                  "16",
                                                                                              },
                                                                                            on: {
                                                                                              input:
                                                                                                _vm.handleTaxpayerInputFormatted,
                                                                                              keyup:
                                                                                                _vm.handleKeyUp,
                                                                                              focus:
                                                                                                _vm.handleFocus,
                                                                                              blur: _vm.handleBlur,
                                                                                            },
                                                                                            scopedSlots:
                                                                                              _vm._u(
                                                                                                [
                                                                                                  _vm
                                                                                                    .customerList
                                                                                                    .length >
                                                                                                  0
                                                                                                    ? {
                                                                                                        key: "append",
                                                                                                        fn: function () {
                                                                                                          return [
                                                                                                            _c(
                                                                                                              "v-icon",
                                                                                                              {
                                                                                                                staticStyle:
                                                                                                                  {
                                                                                                                    color:
                                                                                                                      "var(--light-grey-700) !important",
                                                                                                                  },
                                                                                                                attrs:
                                                                                                                  {
                                                                                                                    size: "20",
                                                                                                                    color:
                                                                                                                      "grey-700",
                                                                                                                  },
                                                                                                              },
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "mdi-chevron-down"
                                                                                                                ),
                                                                                                              ]
                                                                                                            ),
                                                                                                          ]
                                                                                                        },
                                                                                                        proxy: true,
                                                                                                      }
                                                                                                    : null,
                                                                                                ],
                                                                                                null,
                                                                                                true
                                                                                              ),
                                                                                          },
                                                                                          "v-text-field",
                                                                                          attrs,
                                                                                          false
                                                                                        ),
                                                                                        on
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                },
                                                                              },
                                                                            ]
                                                                          ),
                                                                        model: {
                                                                          value:
                                                                            _vm.activeMenu,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.activeMenu =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "activeMenu",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm
                                                                          .customerList
                                                                          .length >
                                                                        0
                                                                          ? _c(
                                                                              "v-list",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    "overflow-y":
                                                                                      "auto",
                                                                                  },
                                                                                attrs:
                                                                                  {
                                                                                    "max-height":
                                                                                      "300",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _vm._l(
                                                                                  _vm.customerList,
                                                                                  function (
                                                                                    customer
                                                                                  ) {
                                                                                    return _c(
                                                                                      "div",
                                                                                      {
                                                                                        key: customer.tax_id,
                                                                                        staticClass:
                                                                                          "d-block px-3 py-2",
                                                                                        staticStyle:
                                                                                          {
                                                                                            cursor:
                                                                                              "pointer",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.selectCustomer(
                                                                                                customer
                                                                                              )
                                                                                            },
                                                                                          mousedown:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              $event.preventDefault()
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "grey-500--text body-2",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              " " +
                                                                                                _vm._s(
                                                                                                  `${
                                                                                                    customer.tax_id ??
                                                                                                    ""
                                                                                                  } • ${
                                                                                                    customer.name ??
                                                                                                    ""
                                                                                                  }`
                                                                                                ) +
                                                                                                " "
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  }
                                                                                ),
                                                                                _vm
                                                                                  .customerList
                                                                                  .length >=
                                                                                10
                                                                                  ? _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "text-center pa-2",
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "span",
                                                                                          {
                                                                                            staticClass:
                                                                                              "grey-400--text caption",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              " Mostrando " +
                                                                                                _vm._s(
                                                                                                  _vm
                                                                                                    .customerList
                                                                                                    .length
                                                                                                ) +
                                                                                                " resultados "
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    )
                                                                                  : _vm._e(),
                                                                              ],
                                                                              2
                                                                            )
                                                                          : _vm
                                                                              .documents
                                                                              .customer
                                                                              .taxpayer &&
                                                                            _vm
                                                                              .documents
                                                                              .customer
                                                                              .taxpayer
                                                                              .length >=
                                                                              3
                                                                          ? _c(
                                                                              "v-list",
                                                                              [
                                                                                _c(
                                                                                  "v-list-item",
                                                                                  [
                                                                                    _c(
                                                                                      "v-list-item-content",
                                                                                      [
                                                                                        _c(
                                                                                          "v-list-item-title",
                                                                                          {
                                                                                            staticClass:
                                                                                              "grey-500--text py-1",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              " No se encontraron clientes "
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ],
                                                                              1
                                                                            )
                                                                          : _vm._e(),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "pa-0 mx-2",
                                                        attrs: { cols: "5" },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "grey-500--text py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Razón social"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          error:
                                                                            _vm
                                                                              .$v
                                                                              .documents
                                                                              .customer
                                                                              .name
                                                                              .$error,
                                                                          oninput:
                                                                            "this.value=this.value.replace(/[^a-zA-Z0-9 ]/g,'');",
                                                                          outlined:
                                                                            "",
                                                                          required:
                                                                            "",
                                                                          "single-line":
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          maxlength:
                                                                            "100",
                                                                          "hide-details":
                                                                            "",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .$v
                                                                              .documents
                                                                              .customer
                                                                              .name
                                                                              .$model,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .$v
                                                                                  .documents
                                                                                  .customer
                                                                                  .name,
                                                                                "$model",
                                                                                typeof $$v ===
                                                                                  "string"
                                                                                  ? $$v.trim()
                                                                                  : $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "$v.documents.customer.name.$model",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm.$store.getters[
                                                      "base/currentCountry"
                                                    ] === "CL"
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 mx-2",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Giro"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        !(
                                                                          _vm
                                                                            .customerAditionals
                                                                            ?.business_activities
                                                                            ?.length &&
                                                                          _vm
                                                                            .customerAditionals
                                                                            .isCustomer
                                                                        )
                                                                          ? _c(
                                                                              "v-text-field",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    error:
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .customer
                                                                                        .business_activity
                                                                                        .$error,
                                                                                    oninput:
                                                                                      "this.value=this.value.replace(/[^a-zA-Z0-9 ]/g,'');",
                                                                                    outlined:
                                                                                      "",
                                                                                    required:
                                                                                      "",
                                                                                    "single-line":
                                                                                      "",
                                                                                    dense:
                                                                                      "",
                                                                                    maxlength:
                                                                                      "40",
                                                                                    "hide-details":
                                                                                      "",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .customer
                                                                                        .business_activity
                                                                                        .$model,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .customer
                                                                                            .business_activity,
                                                                                          "$model",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "$v.documents.customer.business_activity.$model",
                                                                                  },
                                                                              }
                                                                            )
                                                                          : _c(
                                                                              "v-autocomplete",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    error:
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .customer
                                                                                        .business_activity
                                                                                        .$error,
                                                                                    items:
                                                                                      _vm
                                                                                        .customerAditionals
                                                                                        .business_activities,
                                                                                    "single-line":
                                                                                      "",
                                                                                    "hide-details":
                                                                                      "",
                                                                                    height:
                                                                                      "40",
                                                                                    outlined:
                                                                                      "",
                                                                                    dense:
                                                                                      "",
                                                                                    "append-icon":
                                                                                      "mdi-chevron-down",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .customer
                                                                                        .business_activity
                                                                                        .$model,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .customer
                                                                                            .business_activity,
                                                                                          "$model",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "$v.documents.customer.business_activity.$model",
                                                                                  },
                                                                              }
                                                                            ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                [
                                                  "CL110",
                                                  "CL111",
                                                  "CL112",
                                                ].includes(
                                                  _vm.documents.document_type
                                                )
                                                  ? _c(
                                                      "v-row",
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 mx-2",
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Nacionalidad "
                                                                        ),
                                                                        _c(
                                                                          "v-chip",
                                                                          {
                                                                            staticClass:
                                                                              "ml-1 pa-2 caption grey-700--text",
                                                                            attrs:
                                                                              {
                                                                                "x-small":
                                                                                  "",
                                                                                color:
                                                                                  "grey-background",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Opcional"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-autocomplete",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                items:
                                                                                  _vm.nacionalitiesList,
                                                                                "item-value":
                                                                                  "id",
                                                                                "item-text":
                                                                                  "name",
                                                                                "append-icon":
                                                                                  "mdi-chevron-down",
                                                                                "single-line":
                                                                                  "",
                                                                                "hide-details":
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                height:
                                                                                  "40",
                                                                                outlined:
                                                                                  "",
                                                                                "no-data-text":
                                                                                  "No existen países.",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .documents
                                                                                    .customer
                                                                                    .foreign_country,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .documents
                                                                                        .customer,
                                                                                      "foreign_country",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "documents.customer.foreign_country",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 mx-2",
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Número identificador "
                                                                        ),
                                                                        _c(
                                                                          "v-chip",
                                                                          {
                                                                            staticClass:
                                                                              "ml-1 pa-2 caption grey-700--text",
                                                                            attrs:
                                                                              {
                                                                                "x-small":
                                                                                  "",
                                                                                color:
                                                                                  "grey-background",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Opcional"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                outlined:
                                                                                  "",
                                                                                required:
                                                                                  "",
                                                                                "single-line":
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                maxlength:
                                                                                  "28",
                                                                                "hide-details":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .documents
                                                                                    .customer
                                                                                    .foreign_id,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .documents
                                                                                        .customer,
                                                                                      "foreign_id",
                                                                                      typeof $$v ===
                                                                                        "string"
                                                                                        ? $$v.trim()
                                                                                        : $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "documents.customer.foreign_id",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 mx-2",
                                                            attrs: {
                                                              cols: "4",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Identificador adicional de extranjero "
                                                                        ),
                                                                        _c(
                                                                          "v-chip",
                                                                          {
                                                                            staticClass:
                                                                              "ml-1 pa-2 caption grey-700--text",
                                                                            attrs:
                                                                              {
                                                                                "x-small":
                                                                                  "",
                                                                                color:
                                                                                  "grey-background",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Opcional"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                outlined:
                                                                                  "",
                                                                                "single-line":
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                maxlength:
                                                                                  "28",
                                                                                "hide-details":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .documents
                                                                                    .customer
                                                                                    .foreign_additional_id,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .documents
                                                                                        .customer,
                                                                                      "foreign_additional_id",
                                                                                      typeof $$v ===
                                                                                        "string"
                                                                                        ? $$v.trim()
                                                                                        : $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "documents.customer.foreign_additional_id",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "v-row",
                                                  { staticClass: "mt-n2" },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "pa-0 mx-2",
                                                        attrs: { cols: "5" },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "grey-500--text py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Dirección"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    !(
                                                                      _vm
                                                                        .customerAditionals
                                                                        ?.extra_addresses
                                                                        ?.length &&
                                                                      _vm
                                                                        .customerAditionals
                                                                        .isCustomer
                                                                    )
                                                                      ? _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .customer
                                                                                    .address
                                                                                    .$error,
                                                                                oninput:
                                                                                  "this.value=this.value.replace(/[^a-zA-Z0-9,. ]/g,'');",
                                                                                outlined:
                                                                                  "",
                                                                                required:
                                                                                  "",
                                                                                "single-line":
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                maxlength:
                                                                                  "64",
                                                                                "hide-details":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .customer
                                                                                    .address
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .customer
                                                                                        .address,
                                                                                      "$model",
                                                                                      typeof $$v ===
                                                                                        "string"
                                                                                        ? $$v.trim()
                                                                                        : $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.documents.customer.address.$model",
                                                                              },
                                                                          }
                                                                        )
                                                                      : _c(
                                                                          "v-autocomplete",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .customer
                                                                                    .address
                                                                                    .$error,
                                                                                items:
                                                                                  _vm.customerAditionals.extra_addresses.map(
                                                                                    (
                                                                                      item
                                                                                    ) =>
                                                                                      item[0]
                                                                                  ),
                                                                                "single-line":
                                                                                  "",
                                                                                "hide-details":
                                                                                  "",
                                                                                height:
                                                                                  "40",
                                                                                outlined:
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                "append-icon":
                                                                                  "mdi-chevron-down",
                                                                              },
                                                                            on: {
                                                                              change:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.documents.customer.state =
                                                                                    _vm.customerAditionals.extra_addresses?.find(
                                                                                      (
                                                                                        item
                                                                                      ) =>
                                                                                        item[0] ===
                                                                                        _vm
                                                                                          .documents
                                                                                          .customer
                                                                                          .address
                                                                                    )[1] ??
                                                                                    ""
                                                                                },
                                                                            },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "selection",
                                                                                    fn: function (
                                                                                      data
                                                                                    ) {
                                                                                      return [
                                                                                        _c(
                                                                                          "v-list-item-title",
                                                                                          {
                                                                                            staticClass:
                                                                                              "grey-500--text py-1",
                                                                                            staticStyle:
                                                                                              {
                                                                                                "min-width":
                                                                                                  "93% !important",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                data.item
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ]
                                                                              ),
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .customer
                                                                                    .address
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .customer
                                                                                        .address,
                                                                                      "$model",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.documents.customer.address.$model",
                                                                              },
                                                                          }
                                                                        ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    [
                                                      "CL110",
                                                      "CL111",
                                                      "CL112",
                                                    ].includes(
                                                      _vm.documents
                                                        .document_type
                                                    )
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 mx-2",
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "País"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-autocomplete",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .customer
                                                                                    .country
                                                                                    .$error,
                                                                                items:
                                                                                  _vm.simplifiedCountryList,
                                                                                "item-value":
                                                                                  "id",
                                                                                "item-text":
                                                                                  "name",
                                                                                "append-icon":
                                                                                  "mdi-chevron-down",
                                                                                "single-line":
                                                                                  "",
                                                                                "hide-details":
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                height:
                                                                                  "40",
                                                                                outlined:
                                                                                  "",
                                                                                "no-data-text":
                                                                                  "No existen países.",
                                                                              },
                                                                            on: {
                                                                              input:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.$v.documents.customer.country.$touch()
                                                                                },
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .customer
                                                                                    .country
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .customer
                                                                                        .country,
                                                                                      "$model",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.documents.customer.country.$model",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    ![
                                                      "CL110",
                                                      "CL111",
                                                      "CL112",
                                                    ].includes(
                                                      _vm.documents
                                                        .document_type
                                                    )
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 mx-2",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "generals.Comuna"
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-autocomplete",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .customer
                                                                                    .state
                                                                                    .$error,
                                                                                items:
                                                                                  _vm
                                                                                    .$store
                                                                                    .getters[
                                                                                    "base/currentStates"
                                                                                  ] ||
                                                                                  [],
                                                                                "item-value":
                                                                                  "name",
                                                                                "item-text":
                                                                                  "name",
                                                                                "single-line":
                                                                                  "",
                                                                                "hide-details":
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                height:
                                                                                  "40",
                                                                                outlined:
                                                                                  "",
                                                                                placeholder:
                                                                                  "Selecciona la comuna",
                                                                                "no-data-text":
                                                                                  "No existen datos",
                                                                                "append-icon":
                                                                                  "mdi-chevron-down",
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "selection",
                                                                                    fn: function (
                                                                                      data
                                                                                    ) {
                                                                                      return [
                                                                                        _c(
                                                                                          "v-list-item-title",
                                                                                          {
                                                                                            staticClass:
                                                                                              "grey-500--text py-1",
                                                                                            staticStyle:
                                                                                              {
                                                                                                "min-width":
                                                                                                  "93% !important",
                                                                                              },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                data
                                                                                                  .item
                                                                                                  .name
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                false,
                                                                                2087704582
                                                                              ),
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .customer
                                                                                    .state
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .customer
                                                                                        .state,
                                                                                      "$model",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.documents.customer.state.$model",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    ![
                                                      "CL110",
                                                      "CL111",
                                                      "CL112",
                                                    ].includes(
                                                      _vm.documents
                                                        .document_type
                                                    )
                                                      ? _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 mx-2",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Ciudad"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .customer
                                                                                    .city
                                                                                    .$error,
                                                                                oninput:
                                                                                  "this.value=this.value.replace(/[^a-zA-Z0-9,. ]/g,'');",
                                                                                outlined:
                                                                                  "",
                                                                                required:
                                                                                  "",
                                                                                "single-line":
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                maxlength:
                                                                                  "28",
                                                                                "hide-details":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .customer
                                                                                    .city
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .customer
                                                                                        .city,
                                                                                      "$model",
                                                                                      typeof $$v ===
                                                                                        "string"
                                                                                        ? $$v.trim()
                                                                                        : $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.documents.customer.city.$model",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "v-row",
                                                  { staticClass: "mt-n2" },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "pa-0 mx-2",
                                                        attrs: { cols: "5" },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass:
                                                              "pa-0 pb-5",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "d-flex align-center grey-500--text py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Email"
                                                                    ),
                                                                    _c(
                                                                      "v-chip",
                                                                      {
                                                                        staticClass:
                                                                          "ml-1 pa-2 caption grey-700--text",
                                                                        attrs: {
                                                                          "x-small":
                                                                            "",
                                                                          color:
                                                                            "grey-background",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Opcional"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          error:
                                                                            _vm
                                                                              .$v
                                                                              .documents
                                                                              .customer
                                                                              .email
                                                                              .$error,
                                                                          outlined:
                                                                            "",
                                                                          required:
                                                                            "",
                                                                          "single-line":
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          maxlength:
                                                                            "64",
                                                                          "hide-details":
                                                                            "",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .$v
                                                                              .documents
                                                                              .customer
                                                                              .email
                                                                              .$model,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .$v
                                                                                  .documents
                                                                                  .customer
                                                                                  .email,
                                                                                "$model",
                                                                                typeof $$v ===
                                                                                  "string"
                                                                                  ? $$v.trim()
                                                                                  : $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "$v.documents.customer.email.$model",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "v-checkbox",
                                                                      {
                                                                        staticClass:
                                                                          "ml-n1 mt-1",
                                                                        staticStyle:
                                                                          {
                                                                            position:
                                                                              "absolute",
                                                                          },
                                                                        attrs: {
                                                                          color:
                                                                            "grey-900",
                                                                          ripple: false,
                                                                          label:
                                                                            "Utilizar email para el envío del documento",
                                                                          dense:
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm.isExtraEmail,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.isExtraEmail =
                                                                                $$v
                                                                            },
                                                                          expression:
                                                                            "isExtraEmail",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "pa-0 mx-2",
                                                        attrs: { cols: "3" },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "grey-500--text py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Contacto "
                                                                    ),
                                                                    _c(
                                                                      "v-chip",
                                                                      {
                                                                        staticClass:
                                                                          "ml-1 pa-2 caption grey-700--text",
                                                                        attrs: {
                                                                          "x-small":
                                                                            "",
                                                                          color:
                                                                            "grey-background",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Opcional"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _c(
                                                                      "v-text-field",
                                                                      {
                                                                        attrs: {
                                                                          oninput:
                                                                            "this.value=this.value.replace(/[^a-zA-Z0-9,. ]/g,'');",
                                                                          outlined:
                                                                            "",
                                                                          required:
                                                                            "",
                                                                          "single-line":
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          maxlength:
                                                                            "64",
                                                                          "hide-details":
                                                                            "",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .documents
                                                                              .customer
                                                                              .contacts,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .documents
                                                                                  .customer,
                                                                                "contacts",
                                                                                typeof $$v ===
                                                                                  "string"
                                                                                  ? $$v.trim()
                                                                                  : $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "documents.customer.contacts",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        ["CL110", "CL111", "CL112"].includes(
                          _vm.documents.document_type
                        )
                          ? _c(
                              "v-expansion-panels",
                              {
                                staticClass: "mt-5",
                                model: {
                                  value: _vm.panelTransport,
                                  callback: function ($$v) {
                                    _vm.panelTransport = $$v
                                  },
                                  expression: "panelTransport",
                                },
                              },
                              [
                                _c(
                                  "v-expansion-panel",
                                  [
                                    _c(
                                      "v-expansion-panel-header",
                                      { staticClass: "px-5 py-8" },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            attrs: {
                                              "no-gutters": "",
                                              align: "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "subtitle-2 grey-700--text font-weight-semibold d-flex align-center",
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          size: "18",
                                                          color: "grey-700",
                                                        },
                                                      },
                                                      [_vm._v("mdi-truck")]
                                                    ),
                                                    _vm._v(
                                                      "Información de trasporte"
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-expansion-panel-content",
                                      { staticClass: "px-0 pb-5" },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "mt-n2",
                                            attrs: { "no-gutters": "" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "py-0 px-5",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c(
                                                  "v-list",
                                                  {
                                                    staticClass:
                                                      "transparent pa-0",
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        attrs: {
                                                          "no-gutters": "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 mr-5",
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Modalidad de venta"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-autocomplete",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .saleModeCode
                                                                                    .$error,
                                                                                items:
                                                                                  _vm.customsSaleList,
                                                                                "item-value":
                                                                                  "value",
                                                                                "item-text":
                                                                                  "label",
                                                                                "menu-props":
                                                                                  {
                                                                                    overflowY: true,
                                                                                    transition:
                                                                                      "slide-y-transition",
                                                                                  },
                                                                                height:
                                                                                  "40",
                                                                                "single-line":
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                "hide-details":
                                                                                  "",
                                                                                "no-data-text":
                                                                                  "No existen monedas disponibles.",
                                                                                "append-icon":
                                                                                  "mdi-chevron-down",
                                                                                placeholder:
                                                                                  "Selecciona la modalidad de venta",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .saleModeCode
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .saleModeCode,
                                                                                      "$model",
                                                                                      typeof $$v ===
                                                                                        "string"
                                                                                        ? $$v.trim()
                                                                                        : $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.saleModeCode.$model",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        ["CL110", "CL111", "CL112"].includes(
                          _vm.documents.document_type
                        )
                          ? _c(
                              "v-expansion-panels",
                              {
                                staticClass: "mt-5",
                                model: {
                                  value: _vm.panelExport,
                                  callback: function ($$v) {
                                    _vm.panelExport = $$v
                                  },
                                  expression: "panelExport",
                                },
                              },
                              [
                                _c(
                                  "v-expansion-panel",
                                  [
                                    _c(
                                      "v-expansion-panel-header",
                                      { staticClass: "px-5 py-8" },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            attrs: {
                                              "no-gutters": "",
                                              align: "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "subtitle-2 grey-700--text font-weight-semibold d-flex align-center",
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          size: "18",
                                                          color: "grey-700",
                                                        },
                                                      },
                                                      [_vm._v("mdi-earth")]
                                                    ),
                                                    _vm._v(
                                                      "Información de la exportación"
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-expansion-panel-content",
                                      { staticClass: "px-0 pb-5" },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "mt-n2",
                                            attrs: { "no-gutters": "" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "py-0 px-5",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c(
                                                  "v-list",
                                                  {
                                                    staticClass:
                                                      "transparent pa-0",
                                                  },
                                                  [
                                                    _c(
                                                      "v-row",
                                                      {
                                                        attrs: {
                                                          "no-gutters": "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 mr-5",
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Tipo de moneda"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-autocomplete",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .exchange
                                                                                    .currency_from
                                                                                    .$error,
                                                                                items:
                                                                                  _vm.currencies,
                                                                                "menu-props":
                                                                                  {
                                                                                    overflowY: true,
                                                                                    transition:
                                                                                      "slide-y-transition",
                                                                                  },
                                                                                "item-value":
                                                                                  "code",
                                                                                "item-text":
                                                                                  "name",
                                                                                height:
                                                                                  "40",
                                                                                "single-line":
                                                                                  "",
                                                                                outlined:
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                "hide-details":
                                                                                  "",
                                                                                "no-data-text":
                                                                                  "No existen monedas disponibles.",
                                                                                "append-icon":
                                                                                  "mdi-chevron-down",
                                                                                placeholder:
                                                                                  "Selecciona el tipo de moneda",
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "item",
                                                                                    fn: function (
                                                                                      data
                                                                                    ) {
                                                                                      return [
                                                                                        _c(
                                                                                          "v-list-item-title",
                                                                                          {
                                                                                            staticClass:
                                                                                              "font-weight-regular",
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                data
                                                                                                  .item
                                                                                                  .code
                                                                                              ) +
                                                                                                " - " +
                                                                                                _vm._s(
                                                                                                  data
                                                                                                    .item
                                                                                                    .name
                                                                                                )
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                false,
                                                                                2167335655
                                                                              ),
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .exchange
                                                                                    .currency_from
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .exchange
                                                                                        .currency_from,
                                                                                      "$model",
                                                                                      typeof $$v ===
                                                                                        "string"
                                                                                        ? $$v.trim()
                                                                                        : $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.exchange.currency_from.$model",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm.$store.getters[
                                                          "base/currentCountry"
                                                        ] === "CL"
                                                          ? _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                                attrs: {
                                                                  cols: "2",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item",
                                                                  {
                                                                    staticClass:
                                                                      "pa-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          {
                                                                            staticClass:
                                                                              "grey-500--text py-1",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Tipo de cambio"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "v-list-item-subtitle",
                                                                          [
                                                                            _c(
                                                                              "v-text-field",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    error:
                                                                                      _vm
                                                                                        .$v
                                                                                        .exchange
                                                                                        .rate
                                                                                        .$error,
                                                                                    oninput:
                                                                                      "this.value=this.value.replace(/[^0-9.]/g,'');",
                                                                                    suffix:
                                                                                      "CLP",
                                                                                    required:
                                                                                      "",
                                                                                    maxlength:
                                                                                      "12",
                                                                                    "single-line":
                                                                                      "",
                                                                                    outlined:
                                                                                      "",
                                                                                    flat: "",
                                                                                    dense:
                                                                                      "",
                                                                                    "hide-details":
                                                                                      "",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .$v
                                                                                        .exchange
                                                                                        .rate
                                                                                        .$model,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .$v
                                                                                            .exchange
                                                                                            .rate,
                                                                                          "$model",
                                                                                          _vm._n(
                                                                                            $$v
                                                                                          )
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "$v.exchange.rate.$model",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.documents.document_type === "CL52"
                          ? _c(
                              "v-expansion-panels",
                              {
                                staticClass: "mt-5",
                                model: {
                                  value: _vm.panelShipping,
                                  callback: function ($$v) {
                                    _vm.panelShipping = $$v
                                  },
                                  expression: "panelShipping",
                                },
                              },
                              [
                                _c(
                                  "v-expansion-panel",
                                  [
                                    _c(
                                      "v-expansion-panel-header",
                                      { staticClass: "px-5 py-8" },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            attrs: {
                                              "no-gutters": "",
                                              align: "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              { staticClass: "pa-0" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          size: "18",
                                                          color: "grey-700",
                                                        },
                                                      },
                                                      [_vm._v("mdi-truck")]
                                                    ),
                                                    _vm._v(
                                                      "Información de envío"
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-expansion-panel-content",
                                      { staticClass: "px-0 pb-5" },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "mt-n2",
                                            attrs: { "no-gutters": "" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "py-0 px-5",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c(
                                                  "v-list",
                                                  {
                                                    staticClass:
                                                      "transparent pa-0",
                                                  },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass: "pa-0",
                                                        attrs: { cols: "3" },
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            staticClass: "pa-0",
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-content",
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "grey-500--text py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Tipo de envío"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  [
                                                                    _c(
                                                                      "v-select",
                                                                      {
                                                                        attrs: {
                                                                          error:
                                                                            _vm
                                                                              .$v
                                                                              .shipping
                                                                              .type
                                                                              .$error,
                                                                          items:
                                                                            _vm.shippingTypes,
                                                                          "item-text":
                                                                            "label",
                                                                          "item-value":
                                                                            "value",
                                                                          "menu-props":
                                                                            {
                                                                              overflowY: true,
                                                                              transition:
                                                                                "slide-y-transition",
                                                                            },
                                                                          placeholder:
                                                                            "Selecciona el tipo de envío",
                                                                          height:
                                                                            "40",
                                                                          "single-line":
                                                                            "",
                                                                          outlined:
                                                                            "",
                                                                          dense:
                                                                            "",
                                                                          "hide-details":
                                                                            "",
                                                                          "append-icon":
                                                                            "mdi-chevron-down",
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .$v
                                                                              .shipping
                                                                              .type
                                                                              .$model,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm
                                                                                  .$v
                                                                                  .shipping
                                                                                  .type,
                                                                                "$model",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "$v.shipping.type.$model",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass: "mt-n2",
                                                        attrs: {
                                                          "no-gutters": "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass: "pa-0",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "generals.RUT"
                                                                            )
                                                                          ) +
                                                                            " empresa transportista"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm.$store
                                                                      .getters[
                                                                      "base/currentStates"
                                                                    ]
                                                                      ? _c(
                                                                          "v-list-item-subtitle",
                                                                          [
                                                                            _c(
                                                                              "v-text-field",
                                                                              {
                                                                                directives:
                                                                                  [
                                                                                    {
                                                                                      name: "dni",
                                                                                      rawName:
                                                                                        "v-dni",
                                                                                      value:
                                                                                        _vm
                                                                                          .$store
                                                                                          .getters[
                                                                                          "base/currentCountry"
                                                                                        ],
                                                                                      expression:
                                                                                        "$store.getters['base/currentCountry']",
                                                                                    },
                                                                                  ],
                                                                                attrs:
                                                                                  {
                                                                                    error:
                                                                                      _vm
                                                                                        .$v
                                                                                        .shipping
                                                                                        .company_tax_id
                                                                                        .$error,
                                                                                    outlined:
                                                                                      "",
                                                                                    "single-line":
                                                                                      "",
                                                                                    dense:
                                                                                      "",
                                                                                    "hide-details":
                                                                                      "",
                                                                                    maxlength:
                                                                                      "16",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .$v
                                                                                        .shipping
                                                                                        .company_tax_id
                                                                                        .$model,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .$v
                                                                                            .shipping
                                                                                            .company_tax_id,
                                                                                          "$model",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "$v.shipping.company_tax_id.$model",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 mx-3",
                                                            attrs: {
                                                              cols: "4",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Nombre del conductor"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .shipping
                                                                                    .carrier_name
                                                                                    .$error,
                                                                                oninput:
                                                                                  "this.value=this.value.replace(/[^a-zA-Z0-9 ]/g,'');",
                                                                                outlined:
                                                                                  "",
                                                                                "single-line":
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                maxlength:
                                                                                  "30",
                                                                                "hide-details":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .shipping
                                                                                    .carrier_name
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .shipping
                                                                                        .carrier_name,
                                                                                      "$model",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.shipping.carrier_name.$model",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass: "pa-0",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "generals.RUT"
                                                                            )
                                                                          ) +
                                                                            " del conductor"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm.$store
                                                                      .getters[
                                                                      "base/currentStates"
                                                                    ]
                                                                      ? _c(
                                                                          "v-list-item-subtitle",
                                                                          [
                                                                            _c(
                                                                              "v-text-field",
                                                                              {
                                                                                directives:
                                                                                  [
                                                                                    {
                                                                                      name: "dni",
                                                                                      rawName:
                                                                                        "v-dni",
                                                                                      value:
                                                                                        _vm
                                                                                          .$store
                                                                                          .getters[
                                                                                          "base/currentCountry"
                                                                                        ],
                                                                                      expression:
                                                                                        "$store.getters['base/currentCountry']",
                                                                                    },
                                                                                  ],
                                                                                attrs:
                                                                                  {
                                                                                    error:
                                                                                      _vm
                                                                                        .$v
                                                                                        .shipping
                                                                                        .carrier_id
                                                                                        .$error,
                                                                                    outlined:
                                                                                      "",
                                                                                    "single-line":
                                                                                      "",
                                                                                    dense:
                                                                                      "",
                                                                                    "hide-details":
                                                                                      "",
                                                                                    maxlength:
                                                                                      "16",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .$v
                                                                                        .shipping
                                                                                        .carrier_id
                                                                                        .$model,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .$v
                                                                                            .shipping
                                                                                            .carrier_id,
                                                                                          "$model",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "$v.shipping.carrier_id.$model",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ml-3",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Patente del transporte"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm.$store
                                                                      .getters[
                                                                      "base/currentStates"
                                                                    ]
                                                                      ? _c(
                                                                          "v-list-item-subtitle",
                                                                          [
                                                                            _c(
                                                                              "v-text-field",
                                                                              {
                                                                                staticClass:
                                                                                  "pa-0",
                                                                                attrs:
                                                                                  {
                                                                                    outlined:
                                                                                      "",
                                                                                    "single-line":
                                                                                      "",
                                                                                    error:
                                                                                      _vm
                                                                                        .$v
                                                                                        .shipping
                                                                                        .licence_plate
                                                                                        .$error,
                                                                                    oninput:
                                                                                      "this.value=this.value.replace(/[^a-zA-Z0-9]/g,'');",
                                                                                    dense:
                                                                                      "",
                                                                                    maxlength:
                                                                                      "7",
                                                                                    "hide-details":
                                                                                      "",
                                                                                    placeholder:
                                                                                      "Ej        A B   •   C D   •   1 2",
                                                                                  },
                                                                                on: {
                                                                                  change:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.shipping.licence_plate =
                                                                                        _vm.shipping.licence_plate.toUpperCase()
                                                                                    },
                                                                                },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .$v
                                                                                        .shipping
                                                                                        .licence_plate
                                                                                        .$model,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .$v
                                                                                            .shipping
                                                                                            .licence_plate,
                                                                                          "$model",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "$v.shipping.licence_plate.$model",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass: "mt-n2",
                                                        attrs: {
                                                          "no-gutters": "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass: "pa-0",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Patente carro o rampla"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            staticClass:
                                                                              "pa-0",
                                                                            attrs:
                                                                              {
                                                                                outlined:
                                                                                  "",
                                                                                "single-line":
                                                                                  "",
                                                                                oninput:
                                                                                  "this.value=this.value.replace(/[^a-zA-Z0-9]/g,'');",
                                                                                dense:
                                                                                  "",
                                                                                maxlength:
                                                                                  "7",
                                                                                "hide-details":
                                                                                  "",
                                                                                placeholder:
                                                                                  "Ej        A B   •   C D   •   1 2",
                                                                              },
                                                                            on: {
                                                                              change:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  _vm.shipping.trailer_plate =
                                                                                    _vm.shipping.trailer_plate.toUpperCase()
                                                                                },
                                                                            },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .shipping
                                                                                    .trailer_plate,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm.shipping,
                                                                                      "trailer_plate",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "shipping.trailer_plate",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ml-3",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Fecha salida"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-menu",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                "close-on-content-click": false,
                                                                                "offset-y":
                                                                                  "",
                                                                                "nudge-bottom": 10,
                                                                                transition:
                                                                                  "slide-y-transition",
                                                                                "max-width":
                                                                                  "290",
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "activator",
                                                                                    fn: function ({
                                                                                      on,
                                                                                      attrs,
                                                                                    }) {
                                                                                      return [
                                                                                        _c(
                                                                                          "v-text-field",
                                                                                          _vm._g(
                                                                                            _vm._b(
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    "append-icon":
                                                                                                      "mdi-calendar-blank",
                                                                                                    placeholder:
                                                                                                      "dd-mm-aaaa",
                                                                                                    outlined:
                                                                                                      "",
                                                                                                    "single-line":
                                                                                                      "",
                                                                                                    dense:
                                                                                                      "",
                                                                                                    readonly:
                                                                                                      "",
                                                                                                    "hide-details":
                                                                                                      "",
                                                                                                  },
                                                                                                model:
                                                                                                  {
                                                                                                    value:
                                                                                                      _vm
                                                                                                        .shipping
                                                                                                        .departure_date,
                                                                                                    callback:
                                                                                                      function (
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          _vm.shipping,
                                                                                                          "departure_date",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                    expression:
                                                                                                      "shipping.departure_date",
                                                                                                  },
                                                                                              },
                                                                                              "v-text-field",
                                                                                              attrs,
                                                                                              false
                                                                                            ),
                                                                                            on
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                false,
                                                                                2215226782
                                                                              ),
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm.menuDepartureDate,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.menuDepartureDate =
                                                                                      $$v
                                                                                  },
                                                                                expression:
                                                                                  "menuDepartureDate",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-date-picker",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    "no-title":
                                                                                      "",
                                                                                    "first-day-of-week": 1,
                                                                                    type: "date",
                                                                                    locale:
                                                                                      "es",
                                                                                    "max-width":
                                                                                      "290",
                                                                                    color:
                                                                                      "blue-500",
                                                                                  },
                                                                                on: {
                                                                                  input:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.menuDepartureDate = false
                                                                                    },
                                                                                },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .shipping
                                                                                        .departure_date,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm.shipping,
                                                                                          "departure_date",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "shipping.departure_date",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-row",
                                                                                  {
                                                                                    staticClass:
                                                                                      "mb-2 px-6",
                                                                                    attrs:
                                                                                      {
                                                                                        align:
                                                                                          "center",
                                                                                        justify:
                                                                                          "end",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-btn",
                                                                                      {
                                                                                        staticClass:
                                                                                          "body-1",
                                                                                        attrs:
                                                                                          {
                                                                                            ripple: false,
                                                                                            text: "",
                                                                                            color:
                                                                                              "blue-500",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            () => {
                                                                                              _vm.shipping.departure_date =
                                                                                                ""
                                                                                              _vm.menuDepartureDate = false
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "Limpiar"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "v-spacer"
                                                                                    ),
                                                                                    _c(
                                                                                      "v-btn",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            color:
                                                                                              "blue-500",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            () => {
                                                                                              _vm.shipping.departure_date =
                                                                                                _vm.today
                                                                                              _vm.menuDepartureDate = false
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "Hoy"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ml-3",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Hora salida"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-menu",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                "close-on-content-click": false,
                                                                                transition:
                                                                                  "scale-transition",
                                                                                "offset-y":
                                                                                  "",
                                                                                "min-width":
                                                                                  "290px",
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "activator",
                                                                                    fn: function ({
                                                                                      on,
                                                                                      attrs,
                                                                                    }) {
                                                                                      return [
                                                                                        _c(
                                                                                          "v-text-field",
                                                                                          _vm._g(
                                                                                            _vm._b(
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    outlined:
                                                                                                      "",
                                                                                                    "single-line":
                                                                                                      "",
                                                                                                    dense:
                                                                                                      "",
                                                                                                    "hide-details":
                                                                                                      "",
                                                                                                    readonly:
                                                                                                      "",
                                                                                                    "append-icon":
                                                                                                      "mdi-clock-outline",
                                                                                                    placeholder:
                                                                                                      "Ej        1 6   :   4 5",
                                                                                                  },
                                                                                                model:
                                                                                                  {
                                                                                                    value:
                                                                                                      _vm
                                                                                                        .shipping
                                                                                                        .departure_time,
                                                                                                    callback:
                                                                                                      function (
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          _vm.shipping,
                                                                                                          "departure_time",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                    expression:
                                                                                                      "shipping.departure_time",
                                                                                                  },
                                                                                              },
                                                                                              "v-text-field",
                                                                                              attrs,
                                                                                              false
                                                                                            ),
                                                                                            on
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                false,
                                                                                3479736412
                                                                              ),
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm.menuDepartureTime,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.menuDepartureTime =
                                                                                      $$v
                                                                                  },
                                                                                expression:
                                                                                  "menuDepartureTime",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-time-picker",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    format:
                                                                                      "24hr",
                                                                                  },
                                                                                on: {
                                                                                  "click:minute":
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.menuDepartureTime = false
                                                                                    },
                                                                                },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .shipping
                                                                                        .departure_time,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm.shipping,
                                                                                          "departure_time",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "shipping.departure_time",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ml-3",
                                                            attrs: {
                                                              cols: "2",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Fecha llegada a destino"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-menu",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                "close-on-content-click": false,
                                                                                "offset-y":
                                                                                  "",
                                                                                "nudge-bottom": 10,
                                                                                transition:
                                                                                  "slide-y-transition",
                                                                                "max-width":
                                                                                  "290",
                                                                              },
                                                                            scopedSlots:
                                                                              _vm._u(
                                                                                [
                                                                                  {
                                                                                    key: "activator",
                                                                                    fn: function ({
                                                                                      on,
                                                                                      attrs,
                                                                                    }) {
                                                                                      return [
                                                                                        _c(
                                                                                          "v-text-field",
                                                                                          _vm._g(
                                                                                            _vm._b(
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    "append-icon":
                                                                                                      "mdi-calendar-blank",
                                                                                                    placeholder:
                                                                                                      "dd-mm-aaaa",
                                                                                                    outlined:
                                                                                                      "",
                                                                                                    "single-line":
                                                                                                      "",
                                                                                                    dense:
                                                                                                      "",
                                                                                                    readonly:
                                                                                                      "",
                                                                                                    "hide-details":
                                                                                                      "",
                                                                                                  },
                                                                                                model:
                                                                                                  {
                                                                                                    value:
                                                                                                      _vm
                                                                                                        .shipping
                                                                                                        .arrival_date,
                                                                                                    callback:
                                                                                                      function (
                                                                                                        $$v
                                                                                                      ) {
                                                                                                        _vm.$set(
                                                                                                          _vm.shipping,
                                                                                                          "arrival_date",
                                                                                                          $$v
                                                                                                        )
                                                                                                      },
                                                                                                    expression:
                                                                                                      "shipping.arrival_date",
                                                                                                  },
                                                                                              },
                                                                                              "v-text-field",
                                                                                              attrs,
                                                                                              false
                                                                                            ),
                                                                                            on
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    },
                                                                                  },
                                                                                ],
                                                                                null,
                                                                                false,
                                                                                3479915801
                                                                              ),
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm.menuArrivalDate,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.menuArrivalDate =
                                                                                      $$v
                                                                                  },
                                                                                expression:
                                                                                  "menuArrivalDate",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-date-picker",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    "no-title":
                                                                                      "",
                                                                                    "first-day-of-week": 1,
                                                                                    type: "date",
                                                                                    locale:
                                                                                      "es",
                                                                                    "max-width":
                                                                                      "290",
                                                                                    color:
                                                                                      "blue-500",
                                                                                  },
                                                                                on: {
                                                                                  input:
                                                                                    function (
                                                                                      $event
                                                                                    ) {
                                                                                      _vm.menuArrivalDate = false
                                                                                    },
                                                                                },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .shipping
                                                                                        .arrival_date,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm.shipping,
                                                                                          "arrival_date",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "shipping.arrival_date",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-row",
                                                                                  {
                                                                                    staticClass:
                                                                                      "mb-2 px-6",
                                                                                    attrs:
                                                                                      {
                                                                                        align:
                                                                                          "center",
                                                                                        justify:
                                                                                          "end",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-btn",
                                                                                      {
                                                                                        staticClass:
                                                                                          "body-1",
                                                                                        attrs:
                                                                                          {
                                                                                            ripple: false,
                                                                                            text: "",
                                                                                            color:
                                                                                              "blue-500",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            () => {
                                                                                              _vm.shipping.arrival_date =
                                                                                                ""
                                                                                              _vm.menuArrivalDate = false
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "Limpiar"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "v-spacer"
                                                                                    ),
                                                                                    _c(
                                                                                      "v-btn",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            color:
                                                                                              "blue-500",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            () => {
                                                                                              _vm.shipping.arrival_date =
                                                                                                _vm.today
                                                                                              _vm.menuArrivalDate = false
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "Hoy"
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass: "mt-n2",
                                                        attrs: {
                                                          "no-gutters": "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass: "pa-0",
                                                            attrs: {
                                                              cols: "5",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Dirección de envío"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .shipping
                                                                                    .address
                                                                                    .$error,
                                                                                oninput:
                                                                                  "this.value=this.value.replace(/[^a-zA-Z0-9,. ]/g,'');",
                                                                                outlined:
                                                                                  "",
                                                                                "single-line":
                                                                                  "",
                                                                                maxlength:
                                                                                  "70",
                                                                                dense:
                                                                                  "",
                                                                                "hide-details":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .shipping
                                                                                    .address
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .shipping
                                                                                        .address,
                                                                                      "$model",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.shipping.address.$model",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm.$store.getters[
                                                          "base/currentCountry"
                                                        ] === "CL"
                                                          ? _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-0 ml-3",
                                                                attrs: {
                                                                  cols: "3",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item",
                                                                  {
                                                                    staticClass:
                                                                      "pa-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          {
                                                                            staticClass:
                                                                              "grey-500--text py-1",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "generals.Comuna"
                                                                                )
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "v-list-item-subtitle",
                                                                          [
                                                                            _c(
                                                                              "v-autocomplete",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    items:
                                                                                      _vm
                                                                                        .$store
                                                                                        .getters[
                                                                                        "base/currentStates"
                                                                                      ],
                                                                                    "item-value":
                                                                                      "name",
                                                                                    "item-text":
                                                                                      "name",
                                                                                    "menu-props":
                                                                                      {
                                                                                        overflowY: true,
                                                                                        transition:
                                                                                          "slide-y-transition",
                                                                                      },
                                                                                    height:
                                                                                      "40",
                                                                                    "single-line":
                                                                                      "",
                                                                                    outlined:
                                                                                      "",
                                                                                    dense:
                                                                                      "",
                                                                                    "hide-details":
                                                                                      "",
                                                                                    placeholder:
                                                                                      "Selecciona la comuna",
                                                                                    "no-data-text":
                                                                                      "No existen datos",
                                                                                    "append-icon":
                                                                                      "mdi-chevron-down",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .shipping
                                                                                        .state,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm.shipping,
                                                                                          "state",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "shipping.state",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "pa-0 ml-3",
                                                            attrs: {
                                                              cols: "3",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-content",
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "grey-500--text py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Ciudad"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      [
                                                                        _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                error:
                                                                                  _vm
                                                                                    .$v
                                                                                    .shipping
                                                                                    .city
                                                                                    .$error,
                                                                                oninput:
                                                                                  "this.value=this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g,'');",
                                                                                outlined:
                                                                                  "",
                                                                                "single-line":
                                                                                  "",
                                                                                dense:
                                                                                  "",
                                                                                maxlength:
                                                                                  "50",
                                                                                "hide-details":
                                                                                  "",
                                                                              },
                                                                            model:
                                                                              {
                                                                                value:
                                                                                  _vm
                                                                                    .$v
                                                                                    .shipping
                                                                                    .city
                                                                                    .$model,
                                                                                callback:
                                                                                  function (
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      _vm
                                                                                        .$v
                                                                                        .shipping
                                                                                        .city,
                                                                                      "$model",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                expression:
                                                                                  "$v.shipping.city.$model",
                                                                              },
                                                                          }
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-expansion-panels",
                          {
                            staticClass: "mt-5",
                            model: {
                              value: _vm.panelDetail,
                              callback: function ($$v) {
                                _vm.panelDetail = $$v
                              },
                              expression: "panelDetail",
                            },
                          },
                          [
                            _c(
                              "v-expansion-panel",
                              [
                                _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "px-5 py-8" },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        attrs: {
                                          "no-gutters": "",
                                          align: "center",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass:
                                              "pa-0 d-flex align-center",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      size: "18",
                                                      color: "grey-700",
                                                    },
                                                  },
                                                  [_vm._v("mdi-basket")]
                                                ),
                                                _vm._v(
                                                  "Productos y/o servicios"
                                                ),
                                              ],
                                              1
                                            ),
                                            ["CL39"].includes(
                                              _vm.documents.document_type
                                            )
                                              ? _c("v-switch", {
                                                  staticClass: "ma-0 ml-8",
                                                  attrs: {
                                                    label: "Montos netos",
                                                    color: "green-500",
                                                    dense: "",
                                                    "hide-details": "",
                                                    ripple: false,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.isActiveNetAmounts,
                                                    callback: function ($$v) {
                                                      _vm.isActiveNetAmounts =
                                                        $$v
                                                    },
                                                    expression:
                                                      "isActiveNetAmounts",
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-expansion-panel-content",
                                  { staticClass: "px-0 pb-5" },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 mt-n2",
                                        attrs: { "no-gutters": "" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "pt-0 pl-5 pr-3",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _c(
                                              "v-list",
                                              {
                                                staticClass: "transparent pa-0",
                                              },
                                              _vm._l(
                                                _vm.documents.lines,
                                                function (d, i) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: `d-${i}`,
                                                      staticClass:
                                                        "mb-n8 ma-0 pa-0",
                                                    },
                                                    [
                                                      i > 0
                                                        ? _c("v-divider", {
                                                            staticClass:
                                                              "mt-13 mb-5",
                                                          })
                                                        : _vm._e(),
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: {
                                                            "no-gutters": "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "px-0 py-8 mr-2",
                                                              staticStyle: {
                                                                "min-width":
                                                                  "26px",
                                                                "margin-top":
                                                                  "12px",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-chip",
                                                                {
                                                                  staticClass:
                                                                    "px-2",
                                                                  attrs: {
                                                                    id: "product-index",
                                                                    "text-color":
                                                                      "grey-900",
                                                                    color:
                                                                      "green-100",
                                                                    small: "",
                                                                    label: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      i + 1
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "pa-0",
                                                            },
                                                            [
                                                              _c(
                                                                "v-row",
                                                                {
                                                                  staticClass:
                                                                    "flex-nowrap",
                                                                  attrs: {
                                                                    "no-gutters":
                                                                      "",
                                                                    align:
                                                                      "start",
                                                                  },
                                                                },
                                                                [
                                                                  [
                                                                    "CL43",
                                                                  ].includes(
                                                                    _vm
                                                                      .documents
                                                                      .document_type
                                                                  )
                                                                    ? _c(
                                                                        "v-col",
                                                                        {
                                                                          staticClass:
                                                                            "pa-0 mx-2",
                                                                          staticStyle:
                                                                            {
                                                                              "max-width":
                                                                                "240px !important",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              cols: "2",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item",
                                                                            [
                                                                              _c(
                                                                                "v-list-item-content",
                                                                                [
                                                                                  _c(
                                                                                    "v-list-item-title",
                                                                                    {
                                                                                      staticClass:
                                                                                        "grey-500--text py-1",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Tipo de documento a liquidar"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "v-list-item-subtitle",
                                                                                    [
                                                                                      _c(
                                                                                        "v-autocomplete",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              error:
                                                                                                _vm
                                                                                                  .$v
                                                                                                  .documents
                                                                                                  .lines
                                                                                                  .$each[
                                                                                                  i
                                                                                                ]
                                                                                                  .document_type
                                                                                                  .$error,
                                                                                              placeholder:
                                                                                                "Selecciona un tipo de documento",
                                                                                              items:
                                                                                                _vm.currentDocumentList.filter(
                                                                                                  ({
                                                                                                    id,
                                                                                                  }) =>
                                                                                                    ![
                                                                                                      "CL110",
                                                                                                      "CL112",
                                                                                                      "CL111",
                                                                                                      "CL43",
                                                                                                    ].includes(
                                                                                                      id
                                                                                                    )
                                                                                                ),
                                                                                              "item-value":
                                                                                                "id",
                                                                                              "item-text":
                                                                                                "name",
                                                                                              "menu-props":
                                                                                                {
                                                                                                  overflowY: true,
                                                                                                  transition:
                                                                                                    "slide-y-transition",
                                                                                                },
                                                                                              height:
                                                                                                "40",
                                                                                              "single-line":
                                                                                                "",
                                                                                              outlined:
                                                                                                "",
                                                                                              dense:
                                                                                                "",
                                                                                              "hide-details":
                                                                                                "",
                                                                                              "append-icon":
                                                                                                "mdi-chevron-down",
                                                                                              "search-input":
                                                                                                _vm.searchQuery,
                                                                                              filter:
                                                                                                _vm.customFilter,
                                                                                            },
                                                                                          on: {
                                                                                            "update:searchInput":
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                _vm.searchQuery =
                                                                                                  $event
                                                                                              },
                                                                                            "update:search-input":
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                _vm.searchQuery =
                                                                                                  $event
                                                                                              },
                                                                                          },
                                                                                          scopedSlots:
                                                                                            _vm._u(
                                                                                              [
                                                                                                {
                                                                                                  key: "item",
                                                                                                  fn: function (
                                                                                                    data
                                                                                                  ) {
                                                                                                    return [
                                                                                                      _c(
                                                                                                        "v-list-item-title",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "font-weight-regular",
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              data
                                                                                                                .item
                                                                                                                .name
                                                                                                            )
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ]
                                                                                                  },
                                                                                                },
                                                                                                {
                                                                                                  key: "selection",
                                                                                                  fn: function (
                                                                                                    data
                                                                                                  ) {
                                                                                                    return [
                                                                                                      _c(
                                                                                                        "v-list-item-title",
                                                                                                        {
                                                                                                          staticClass:
                                                                                                            "grey-500--text py-1",
                                                                                                          staticStyle:
                                                                                                            {
                                                                                                              "min-width":
                                                                                                                "220px !important",
                                                                                                            },
                                                                                                        },
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              data
                                                                                                                .item
                                                                                                                .name
                                                                                                            )
                                                                                                          ),
                                                                                                        ]
                                                                                                      ),
                                                                                                    ]
                                                                                                  },
                                                                                                },
                                                                                              ],
                                                                                              null,
                                                                                              true
                                                                                            ),
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                _vm
                                                                                                  .$v
                                                                                                  .documents
                                                                                                  .lines
                                                                                                  .$each[
                                                                                                  i
                                                                                                ]
                                                                                                  .document_type
                                                                                                  .$model,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    _vm
                                                                                                      .$v
                                                                                                      .documents
                                                                                                      .lines
                                                                                                      .$each[
                                                                                                      i
                                                                                                    ]
                                                                                                      .document_type,
                                                                                                    "$model",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "$v.documents.lines.$each[i].document_type.$model",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0 mx-2",
                                                                      attrs: {
                                                                        cols: "2",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item",
                                                                        {
                                                                          staticClass:
                                                                            "pa-0",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-content",
                                                                            [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                {
                                                                                  staticClass:
                                                                                    "grey-500--text d-flex align-center py-1",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Tipo de código"
                                                                                  ),
                                                                                  _c(
                                                                                    "v-chip",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ml-1 pa-2 caption grey-700--text",
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                          color:
                                                                                            "grey-background",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Opcional"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _c(
                                                                                "v-list-item-subtitle",
                                                                                [
                                                                                  _c(
                                                                                    "v-text-field",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          error:
                                                                                            _vm
                                                                                              .$v
                                                                                              .documents
                                                                                              .lines
                                                                                              .$each[
                                                                                              i
                                                                                            ]
                                                                                              .code_scheme
                                                                                              .$error,
                                                                                          oninput:
                                                                                            "this.value=this.value.replace(/[^a-zA-Z0-9,.-_ ]/g,'');",
                                                                                          maxlength:
                                                                                            "10",
                                                                                          outlined:
                                                                                            "",
                                                                                          "single-line":
                                                                                            "",
                                                                                          solo: "",
                                                                                          flat: "",
                                                                                          dense:
                                                                                            "",
                                                                                          "hide-details":
                                                                                            "",
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            _vm
                                                                                              .$v
                                                                                              .documents
                                                                                              .lines
                                                                                              .$each[
                                                                                              i
                                                                                            ]
                                                                                              .code_scheme
                                                                                              .$model,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .$v
                                                                                                  .documents
                                                                                                  .lines
                                                                                                  .$each[
                                                                                                  i
                                                                                                ]
                                                                                                  .code_scheme,
                                                                                                "$model",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "$v.documents.lines.$each[i].code_scheme.$model",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0 mx-2",
                                                                      attrs: {
                                                                        cols: "2",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item",
                                                                        {
                                                                          staticClass:
                                                                            "pa-0",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-content",
                                                                            [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                {
                                                                                  staticClass:
                                                                                    "grey-500--text d-flex align-center py-1",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Código"
                                                                                  ),
                                                                                  _c(
                                                                                    "v-chip",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ml-1 pa-2 caption grey-700--text",
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                          color:
                                                                                            "grey-background",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Opcional"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _c(
                                                                                "v-list-item-subtitle",
                                                                                [
                                                                                  _c(
                                                                                    "v-text-field",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          error:
                                                                                            _vm
                                                                                              .$v
                                                                                              .documents
                                                                                              .lines
                                                                                              .$each[
                                                                                              i
                                                                                            ]
                                                                                              .code
                                                                                              .$error,
                                                                                          oninput:
                                                                                            "this.value=this.value.replace(/[^a-zA-Z0-9]/g,'');",
                                                                                          maxlength:
                                                                                            "35",
                                                                                          outlined:
                                                                                            "",
                                                                                          "single-line":
                                                                                            "",
                                                                                          solo: "",
                                                                                          flat: "",
                                                                                          dense:
                                                                                            "",
                                                                                          "hide-details":
                                                                                            "",
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            _vm
                                                                                              .$v
                                                                                              .documents
                                                                                              .lines
                                                                                              .$each[
                                                                                              i
                                                                                            ]
                                                                                              .code
                                                                                              .$model,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .$v
                                                                                                  .documents
                                                                                                  .lines
                                                                                                  .$each[
                                                                                                  i
                                                                                                ]
                                                                                                  .code,
                                                                                                "$model",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "$v.documents.lines.$each[i].code.$model",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0 mx-2",
                                                                      attrs: {
                                                                        cols: "4",
                                                                        sm:
                                                                          _vm
                                                                            .$vuetify
                                                                            .breakpoint
                                                                            .width <=
                                                                          1200
                                                                            ? 2
                                                                            : 3,
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item",
                                                                        {
                                                                          staticClass:
                                                                            "pa-0",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-content",
                                                                            [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                {
                                                                                  staticClass:
                                                                                    "grey-500--text py-1",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Nombre"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "v-list-item-subtitle",
                                                                                [
                                                                                  _c(
                                                                                    "v-text-field",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          error:
                                                                                            _vm
                                                                                              .$v
                                                                                              .documents
                                                                                              .lines
                                                                                              .$each[
                                                                                              i
                                                                                            ]
                                                                                              .name
                                                                                              .$error,
                                                                                          required:
                                                                                            "",
                                                                                          maxlength:
                                                                                            "80",
                                                                                          outlined:
                                                                                            "",
                                                                                          flat: "",
                                                                                          solo: "",
                                                                                          dense:
                                                                                            "",
                                                                                          "hide-details":
                                                                                            "",
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            _vm
                                                                                              .$v
                                                                                              .documents
                                                                                              .lines
                                                                                              .$each[
                                                                                              i
                                                                                            ]
                                                                                              .name
                                                                                              .$model,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .$v
                                                                                                  .documents
                                                                                                  .lines
                                                                                                  .$each[
                                                                                                  i
                                                                                                ]
                                                                                                  .name,
                                                                                                "$model",
                                                                                                typeof $$v ===
                                                                                                  "string"
                                                                                                  ? $$v.trim()
                                                                                                  : $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "$v.documents.lines.$each[i].name.$model",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0 mx-2",
                                                                      staticStyle:
                                                                        {
                                                                          "min-width":
                                                                            "90px !important",
                                                                          "max-width":
                                                                            "auto !important",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item",
                                                                        {
                                                                          staticClass:
                                                                            "pa-0",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-content",
                                                                            [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                {
                                                                                  staticClass:
                                                                                    "grey-500--text d-flex align-center py-1",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Descripción"
                                                                                  ),
                                                                                  _c(
                                                                                    "v-chip",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ml-1 pa-2 caption grey-700--text",
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                          color:
                                                                                            "grey-background",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Opcional"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _c(
                                                                                "v-list-item-subtitle",
                                                                                [
                                                                                  _c(
                                                                                    "v-textarea",
                                                                                    {
                                                                                      staticClass:
                                                                                        "description-field",
                                                                                      attrs:
                                                                                        {
                                                                                          error:
                                                                                            _vm
                                                                                              .$v
                                                                                              .documents
                                                                                              .lines
                                                                                              .$each[
                                                                                              i
                                                                                            ]
                                                                                              .description
                                                                                              .$error,
                                                                                          required:
                                                                                            "",
                                                                                          maxlength:
                                                                                            "1000",
                                                                                          rows: "1",
                                                                                          "auto-grow":
                                                                                            "",
                                                                                          solo: "",
                                                                                          outlined:
                                                                                            "",
                                                                                          flat: "",
                                                                                          dense:
                                                                                            "",
                                                                                          "hide-details":
                                                                                            "",
                                                                                        },
                                                                                      nativeOn:
                                                                                        {
                                                                                          mousedown:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.trackDescriptionResize(
                                                                                                $event.target
                                                                                              )
                                                                                            },
                                                                                          input:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.keepDescriptionHeight(
                                                                                                $event.target
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            _vm
                                                                                              .$v
                                                                                              .documents
                                                                                              .lines
                                                                                              .$each[
                                                                                              i
                                                                                            ]
                                                                                              .description
                                                                                              .$model,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .$v
                                                                                                  .documents
                                                                                                  .lines
                                                                                                  .$each[
                                                                                                  i
                                                                                                ]
                                                                                                  .description,
                                                                                                "$model",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "$v.documents.lines.$each[i].description.$model",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-row",
                                                        {
                                                          staticClass: "mt-n4",
                                                          attrs: {
                                                            "no-gutters": "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex mr-2",
                                                              staticStyle: {
                                                                width:
                                                                  "calc(17.5% + 26px) !important",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "pa-0 mr-2",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-content",
                                                                        [
                                                                          _c(
                                                                            "v-list-item-title",
                                                                            {
                                                                              staticClass:
                                                                                "grey-500--text d-flex align-center py-1",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Unidad"
                                                                              ),
                                                                              _c(
                                                                                "v-chip",
                                                                                {
                                                                                  staticClass:
                                                                                    "ml-1 pa-2 caption grey-700--text",
                                                                                  attrs:
                                                                                    {
                                                                                      "x-small":
                                                                                        "",
                                                                                      color:
                                                                                        "grey-background",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Opcional"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "v-list-item-subtitle",
                                                                            [
                                                                              _c(
                                                                                "v-select",
                                                                                {
                                                                                  staticClass:
                                                                                    "select-document",
                                                                                  attrs:
                                                                                    {
                                                                                      items:
                                                                                        _vm.unitLabel,
                                                                                      "menu-props":
                                                                                        {
                                                                                          overflowY: true,
                                                                                          transition:
                                                                                            "slide-y-transition",
                                                                                        },
                                                                                      "single-line":
                                                                                        "",
                                                                                      outlined:
                                                                                        "",
                                                                                      dense:
                                                                                        "",
                                                                                      "hide-details":
                                                                                        "",
                                                                                      "no-data-text":
                                                                                        "No existen unidaddes disponibles",
                                                                                      placeholder:
                                                                                        "Selecciona",
                                                                                      "append-icon":
                                                                                        "mdi-chevron-down",
                                                                                    },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm
                                                                                          .documents
                                                                                          .lines[
                                                                                          i
                                                                                        ]
                                                                                          .unit_label,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .documents
                                                                                              .lines[
                                                                                              i
                                                                                            ],
                                                                                            "unit_label",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                      expression:
                                                                                        "documents.lines[i].unit_label",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "pa-0 ml-2",
                                                                  staticStyle: {
                                                                    "min-width":
                                                                      "70px !important",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-content",
                                                                        [
                                                                          _c(
                                                                            "v-list-item-title",
                                                                            {
                                                                              staticClass:
                                                                                "grey-500--text py-1",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Cantidad"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "v-list-item-subtitle",
                                                                            [
                                                                              _c(
                                                                                "v-text-field",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      error:
                                                                                        _vm
                                                                                          .$v
                                                                                          .documents
                                                                                          .lines
                                                                                          .$each[
                                                                                          i
                                                                                        ]
                                                                                          .quantity
                                                                                          .$error,
                                                                                      oninput:
                                                                                        "this.value=this.value.replace(/[^0-9.]/g,'');",
                                                                                      required:
                                                                                        "",
                                                                                      maxlength:
                                                                                        "12",
                                                                                      outlined:
                                                                                        "",
                                                                                      flat: "",
                                                                                      solo: "",
                                                                                      dense:
                                                                                        "",
                                                                                      "hide-details":
                                                                                        "",
                                                                                    },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm
                                                                                          .$v
                                                                                          .documents
                                                                                          .lines
                                                                                          .$each[
                                                                                          i
                                                                                        ]
                                                                                          .quantity
                                                                                          .$model,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .$v
                                                                                              .documents
                                                                                              .lines
                                                                                              .$each[
                                                                                              i
                                                                                            ]
                                                                                              .quantity,
                                                                                            "$model",
                                                                                            _vm._n(
                                                                                              $$v
                                                                                            )
                                                                                          )
                                                                                        },
                                                                                      expression:
                                                                                        "$v.documents.lines.$each[i].quantity.$model",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "pa-0 mx-2",
                                                              staticStyle: {
                                                                "min-width":
                                                                  "16.2% !important",
                                                              },
                                                              attrs: {
                                                                cols: "1",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item",
                                                                {
                                                                  staticClass:
                                                                    "pa-0",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item-content",
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        {
                                                                          staticClass:
                                                                            "grey-500--text py-1",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Precio"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "v-list-item-subtitle",
                                                                        [
                                                                          _c(
                                                                            "v-text-field",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  error:
                                                                                    _vm
                                                                                      .$v
                                                                                      .documents
                                                                                      .lines
                                                                                      .$each[
                                                                                      i
                                                                                    ]
                                                                                      .amount
                                                                                      .$error,
                                                                                  oninput:
                                                                                    "this.value=this.value.replace(/[^0-9.]/g,'');",
                                                                                  required:
                                                                                    "",
                                                                                  maxlength:
                                                                                    "18",
                                                                                  "single-line":
                                                                                    "",
                                                                                  reverse:
                                                                                    "",
                                                                                  outlined:
                                                                                    "",
                                                                                  flat: "",
                                                                                  solo: "",
                                                                                  dense:
                                                                                    "",
                                                                                  "hide-details":
                                                                                    "",
                                                                                  suffix:
                                                                                    "$",
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .$v
                                                                                      .documents
                                                                                      .lines
                                                                                      .$each[
                                                                                      i
                                                                                    ]
                                                                                      .amount
                                                                                      .$model,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .$v
                                                                                          .documents
                                                                                          .lines
                                                                                          .$each[
                                                                                          i
                                                                                        ]
                                                                                          .amount,
                                                                                        "$model",
                                                                                        _vm._n(
                                                                                          $$v
                                                                                        )
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "$v.documents.lines.$each[i].amount.$model",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "pa-0 mx-2",
                                                              staticStyle: {
                                                                "min-width":
                                                                  "150px !important",
                                                              },
                                                              attrs: {
                                                                cols: "1",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-item",
                                                                {
                                                                  staticClass:
                                                                    "pa-0",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item-content",
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        {
                                                                          staticClass:
                                                                            "grey-500--text d-flex align-center py-1",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Descuento"
                                                                          ),
                                                                          _c(
                                                                            "v-chip",
                                                                            {
                                                                              staticClass:
                                                                                "ml-1 pa-2 caption grey-700--text",
                                                                              attrs:
                                                                                {
                                                                                  "x-small":
                                                                                    "",
                                                                                  color:
                                                                                    "grey-background",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "Opcional"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "v-list-item-subtitle",
                                                                        [
                                                                          _c(
                                                                            "v-text-field",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  oninput:
                                                                                    "this.value=this.value.replace(/[^0-9]/g,'');",
                                                                                  height:
                                                                                    "26",
                                                                                  outlined:
                                                                                    "",
                                                                                  "single-line":
                                                                                    "",
                                                                                  solo: "",
                                                                                  flat: "",
                                                                                  dense:
                                                                                    "",
                                                                                  "hide-details":
                                                                                    "",
                                                                                },
                                                                              scopedSlots:
                                                                                _vm._u(
                                                                                  [
                                                                                    {
                                                                                      key: "prepend-inner",
                                                                                      fn: function () {
                                                                                        return [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mr-0",
                                                                                              staticStyle:
                                                                                                {
                                                                                                  width:
                                                                                                    "35px",
                                                                                                },
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "v-select",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "select-discount",
                                                                                                  attrs:
                                                                                                    {
                                                                                                      items:
                                                                                                        _vm.discountSchemes,
                                                                                                      "item-text":
                                                                                                        "value",
                                                                                                      "item-value":
                                                                                                        "value",
                                                                                                      solo: "",
                                                                                                      flat: "",
                                                                                                      "hide-details":
                                                                                                        "",
                                                                                                      "append-icon":
                                                                                                        "mdi-chevron-down",
                                                                                                      "menu-props":
                                                                                                        {
                                                                                                          overflowY: false,
                                                                                                          transition:
                                                                                                            "slide-y-transition",
                                                                                                          bottom: true,
                                                                                                        },
                                                                                                    },
                                                                                                  model:
                                                                                                    {
                                                                                                      value:
                                                                                                        d.discount_scheme,
                                                                                                      callback:
                                                                                                        function (
                                                                                                          $$v
                                                                                                        ) {
                                                                                                          _vm.$set(
                                                                                                            d,
                                                                                                            "discount_scheme",
                                                                                                            $$v
                                                                                                          )
                                                                                                        },
                                                                                                      expression:
                                                                                                        "d.discount_scheme",
                                                                                                    },
                                                                                                }
                                                                                              ),
                                                                                            ],
                                                                                            1
                                                                                          ),
                                                                                        ]
                                                                                      },
                                                                                      proxy: true,
                                                                                    },
                                                                                  ],
                                                                                  null,
                                                                                  true
                                                                                ),
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .documents
                                                                                      .lines[
                                                                                      i
                                                                                    ]
                                                                                      .discount,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .documents
                                                                                          .lines[
                                                                                          i
                                                                                        ],
                                                                                        "discount",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "documents.lines[i].discount",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm.currentIrsTax
                                                            .length &&
                                                          !(
                                                            _vm.documents
                                                              .document_type ===
                                                              "CL33" &&
                                                            _vm.documents.lines[
                                                              i
                                                            ].exempt
                                                          )
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "pa-0 mx-2",
                                                                  attrs: {
                                                                    cols:
                                                                      _vm
                                                                        .$vuetify
                                                                        .breakpoint
                                                                        .width <=
                                                                      1300
                                                                        ? 2
                                                                        : 3,
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-content",
                                                                        [
                                                                          _c(
                                                                            "v-list-item-title",
                                                                            {
                                                                              staticClass:
                                                                                "grey-500--text d-flex align-center py-1",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    "Otros impuestos"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm
                                                                                .documents
                                                                                .document_type !==
                                                                              "CL46"
                                                                                ? _c(
                                                                                    "v-chip",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ml-1 pa-2 caption grey-700--text",
                                                                                      attrs:
                                                                                        {
                                                                                          "x-small":
                                                                                            "",
                                                                                          color:
                                                                                            "grey-background",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Opcional"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ],
                                                                            1
                                                                          ),
                                                                          _c(
                                                                            "v-list-item-subtitle",
                                                                            [
                                                                              _c(
                                                                                "v-select",
                                                                                {
                                                                                  staticClass:
                                                                                    "select-document",
                                                                                  attrs:
                                                                                    {
                                                                                      items:
                                                                                        _vm.currentIrsTax,
                                                                                      "item-value":
                                                                                        "id",
                                                                                      "item-text":
                                                                                        "label",
                                                                                      "return-object":
                                                                                        "",
                                                                                      "menu-props":
                                                                                        {
                                                                                          overflowY: true,
                                                                                          transition:
                                                                                            "slide-y-transition",
                                                                                        },
                                                                                      "single-line":
                                                                                        "",
                                                                                      height:
                                                                                        "16",
                                                                                      outlined:
                                                                                        "",
                                                                                      dense:
                                                                                        "",
                                                                                      "hide-details":
                                                                                        "",
                                                                                      "no-data-text":
                                                                                        "No existen impuestos disponibles",
                                                                                      placeholder:
                                                                                        "Selecciona",
                                                                                      "append-icon":
                                                                                        "mdi-chevron-down",
                                                                                    },
                                                                                  scopedSlots:
                                                                                    _vm._u(
                                                                                      [
                                                                                        {
                                                                                          key: "item",
                                                                                          fn: function (
                                                                                            data
                                                                                          ) {
                                                                                            return [
                                                                                              _c(
                                                                                                "v-list-item-title",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-weight-regular",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      data
                                                                                                        .item
                                                                                                        .label
                                                                                                    ) +
                                                                                                      " " +
                                                                                                      _vm._s(
                                                                                                        data
                                                                                                          .item
                                                                                                          .value
                                                                                                      ) +
                                                                                                      "%"
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          },
                                                                                        },
                                                                                        {
                                                                                          key: "selection",
                                                                                          fn: function (
                                                                                            data
                                                                                          ) {
                                                                                            return [
                                                                                              _c(
                                                                                                "v-list-item-title",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "font-weight-regular pl-2",
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      data
                                                                                                        .item
                                                                                                        .label
                                                                                                    ) +
                                                                                                      " " +
                                                                                                      _vm._s(
                                                                                                        data
                                                                                                          .item
                                                                                                          .value
                                                                                                      ) +
                                                                                                      "%"
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          },
                                                                                        },
                                                                                      ],
                                                                                      null,
                                                                                      true
                                                                                    ),
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm
                                                                                          .documents
                                                                                          .lines[
                                                                                          i
                                                                                        ]
                                                                                          .irs_tax_code,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .documents
                                                                                              .lines[
                                                                                              i
                                                                                            ],
                                                                                            "irs_tax_code",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                      expression:
                                                                                        "documents.lines[i].irs_tax_code",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _c("v-spacer"),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "pa-0 mx-2",
                                                              staticStyle: {
                                                                "min-width":
                                                                  "200px !important",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "d-flex",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      staticClass:
                                                                        "pa-0 mr-3",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item",
                                                                        {
                                                                          staticClass:
                                                                            "pa-0",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-content",
                                                                            [
                                                                              _c(
                                                                                "v-list-item-title",
                                                                                {
                                                                                  staticClass:
                                                                                    "font-weight-bold text-right py-1",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "Subtotal"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "v-list-item-subtitle",
                                                                                {
                                                                                  staticClass:
                                                                                    "mt-2 font-weight-medium text-right",
                                                                                },
                                                                                [
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .lines
                                                                                    .$each[
                                                                                    i
                                                                                  ]
                                                                                    .amount
                                                                                    .$error ||
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .lines
                                                                                    .$each[
                                                                                    i
                                                                                  ]
                                                                                    .discount
                                                                                    .$error ||
                                                                                  _vm
                                                                                    .$v
                                                                                    .documents
                                                                                    .lines
                                                                                    .$each[
                                                                                    i
                                                                                  ]
                                                                                    .quantity
                                                                                    .$error
                                                                                    ? [
                                                                                        _vm._v(
                                                                                          "-"
                                                                                        ),
                                                                                      ]
                                                                                    : [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$fmt.currency(
                                                                                              _vm.documentCurrency,
                                                                                              _vm
                                                                                                .aggregations
                                                                                                .lines[
                                                                                                i
                                                                                              ]
                                                                                                .totalItem ||
                                                                                                0
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ],
                                                                                ],
                                                                                2
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  ![
                                                                    "CL34",
                                                                    "CL41",
                                                                  ].includes(
                                                                    _vm
                                                                      .documents
                                                                      .document_type
                                                                  )
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "pa-0",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item",
                                                                            {
                                                                              staticClass:
                                                                                "pa-0",
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "43px !important",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-list-item-content",
                                                                                [
                                                                                  _c(
                                                                                    "v-list-item-title",
                                                                                    {
                                                                                      staticClass:
                                                                                        "grey-500--text py-1",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Exento"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                  _c(
                                                                                    "v-list-item-subtitle",
                                                                                    {
                                                                                      staticClass:
                                                                                        "ml-1",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "v-switch",
                                                                                        {
                                                                                          staticClass:
                                                                                            "ma-0",
                                                                                          staticStyle:
                                                                                            {
                                                                                              position:
                                                                                                "absolute",
                                                                                              top: "36px",
                                                                                            },
                                                                                          attrs:
                                                                                            {
                                                                                              color:
                                                                                                "green-500",
                                                                                              dense:
                                                                                                "",
                                                                                              "hide-details":
                                                                                                "",
                                                                                              ripple: false,
                                                                                            },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                _vm
                                                                                                  .documents
                                                                                                  .lines[
                                                                                                  i
                                                                                                ]
                                                                                                  .exempt,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    _vm
                                                                                                      .documents
                                                                                                      .lines[
                                                                                                      i
                                                                                                    ],
                                                                                                    "exempt",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "documents.lines[i].exempt",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  i > 0
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "px-0 py-8 text-right",
                                                                          staticStyle:
                                                                            {
                                                                              "min-width":
                                                                                "35px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-btn",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  disabled:
                                                                                    _vm
                                                                                      .documents
                                                                                      .lines
                                                                                      .length ===
                                                                                    1,
                                                                                  "min-width":
                                                                                    "20",
                                                                                  "max-width":
                                                                                    "20",
                                                                                  "min-height":
                                                                                    "28",
                                                                                  "max-height":
                                                                                    "28",
                                                                                  text: "",
                                                                                  color:
                                                                                    "grey-200",
                                                                                  ripple: false,
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.documents.lines.splice(
                                                                                      i,
                                                                                      1
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "v-icon",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      size: "24",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "mdi-delete"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { staticClass: "px-5 mt-5 text-left" },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              text: "",
                                              color: "grey-900",
                                              ripple: false,
                                            },
                                            on: { click: _vm.addDocumentsLine },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { left: "" } },
                                              [_vm._v("mdi-basket-plus")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "font-weight-medium body-1",
                                              },
                                              [_vm._v("Agregar producto")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider", {
                                      staticClass: "mt-2 mb-3",
                                    }),
                                    _c(
                                      "v-row",
                                      {
                                        attrs: {
                                          align: "center",
                                          justify: "end",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "px-0 py-5",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c(
                                              "v-list",
                                              {
                                                staticClass:
                                                  "v-list-form transparent pa-0",
                                              },
                                              [
                                                _c(
                                                  "v-list-item",
                                                  { staticClass: "py-0 px-8" },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "subtitle-2 py-1",
                                                      },
                                                      [_vm._v("Subtotal")]
                                                    ),
                                                    _c(
                                                      "v-list-item-subtitle",
                                                      {
                                                        staticClass:
                                                          "text-right font-weight-bold grey-700--text",
                                                      },
                                                      [
                                                        _vm
                                                          .linesWithAmountsError
                                                          .length
                                                          ? [_vm._v("-")]
                                                          : [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.currency(
                                                                    _vm.documentCurrency,
                                                                    _vm
                                                                      .aggregations
                                                                      .subtotal
                                                                  )
                                                                )
                                                              ),
                                                            ],
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                !_vm.aggregations.irs_tax
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        staticClass:
                                                          "py-0 px-8",
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "subtitle-2 py-1",
                                                          },
                                                          [_vm._v("Descuento")]
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "d-flex",
                                                          },
                                                          [
                                                            _c("v-spacer"),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "text-right pa-0",
                                                                staticStyle: {
                                                                  "min-width":
                                                                    "150px !important",
                                                                },
                                                                attrs: {
                                                                  cols: "5",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-text-field",
                                                                  {
                                                                    attrs: {
                                                                      oninput:
                                                                        "this.value=this.value.replace(/[^0-9]/g,'');",
                                                                      height:
                                                                        "26",
                                                                      outlined:
                                                                        "",
                                                                      "single-line":
                                                                        "",
                                                                      solo: "",
                                                                      flat: "",
                                                                      dense: "",
                                                                      "hide-details":
                                                                        "",
                                                                    },
                                                                    scopedSlots:
                                                                      _vm._u(
                                                                        [
                                                                          {
                                                                            key: "prepend-inner",
                                                                            fn: function () {
                                                                              return [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "mr-0",
                                                                                    staticStyle:
                                                                                      {
                                                                                        width:
                                                                                          "35px",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-select",
                                                                                      {
                                                                                        staticClass:
                                                                                          "select-discount",
                                                                                        attrs:
                                                                                          {
                                                                                            items:
                                                                                              _vm.discountSchemes,
                                                                                            "item-text":
                                                                                              "value",
                                                                                            "item-value":
                                                                                              "value",
                                                                                            solo: "",
                                                                                            flat: "",
                                                                                            "hide-details":
                                                                                              "",
                                                                                            "append-icon":
                                                                                              "mdi-chevron-down",
                                                                                          },
                                                                                        model:
                                                                                          {
                                                                                            value:
                                                                                              _vm
                                                                                                .documents
                                                                                                .discount_scheme,
                                                                                            callback:
                                                                                              function (
                                                                                                $$v
                                                                                              ) {
                                                                                                _vm.$set(
                                                                                                  _vm.documents,
                                                                                                  "discount_scheme",
                                                                                                  $$v
                                                                                                )
                                                                                              },
                                                                                            expression:
                                                                                              "documents.discount_scheme",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            },
                                                                            proxy: true,
                                                                          },
                                                                        ],
                                                                        null,
                                                                        false,
                                                                        3332850804
                                                                      ),
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .documents
                                                                          .discount,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.documents,
                                                                            "discount",
                                                                            _vm._n(
                                                                              $$v
                                                                            )
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "documents.discount",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm.aggregations
                                                              .discount &&
                                                            _vm.documents
                                                              .discount_scheme ===
                                                              "%"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$fmt.integer(
                                                                        _vm
                                                                          .aggregations
                                                                          .discount
                                                                      )
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                !_vm.$v.documents.discount
                                                  .maxAmount ||
                                                !_vm.$v.documents.discount
                                                  .maxPercent
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        staticClass:
                                                          "py-0 px-8 text-right",
                                                      },
                                                      [
                                                        !_vm.$v.documents
                                                          .discount.maxAmount
                                                          ? _c(
                                                              "v-list-item-title",
                                                              {
                                                                staticClass:
                                                                  "red--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "El descuento no puede superar el subtotal"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        !_vm.$v.documents
                                                          .discount.maxPercent
                                                          ? _c(
                                                              "v-list-item-title",
                                                              {
                                                                staticClass:
                                                                  "red--text",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "El descuento no puede superar el 100%"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm.activeDocument
                                                  .has_taxes_detail
                                                  ? [
                                                      _c("v-divider", {
                                                        staticClass:
                                                          "mx-8 my-1",
                                                      }),
                                                      _c(
                                                        "v-list-item",
                                                        {
                                                          staticClass:
                                                            "py-0 px-8",
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-title",
                                                            {
                                                              staticClass:
                                                                "subtitle-2 py-1",
                                                            },
                                                            [_vm._v("Exento")]
                                                          ),
                                                          _c(
                                                            "v-list-item-subtitle",
                                                            {
                                                              staticClass:
                                                                "text-right font-weight-bold grey-700--text",
                                                            },
                                                            [
                                                              (
                                                                _vm.linesWithAmountsError ||
                                                                []
                                                              ).length ||
                                                              !_vm.$v.documents
                                                                .discount
                                                                .maxAmount ||
                                                              !_vm.$v.documents
                                                                .discount
                                                                .maxPercent
                                                                ? [_vm._v("-")]
                                                                : [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$fmt.currency(
                                                                          _vm.documentCurrency,
                                                                          _vm
                                                                            .aggregations
                                                                            .exempt
                                                                        )
                                                                      )
                                                                    ),
                                                                  ],
                                                            ],
                                                            2
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _vm.activeDocument
                                                        .has_taxes
                                                        ? [
                                                            _c(
                                                              "v-list-item",
                                                              {
                                                                staticClass:
                                                                  "py-0 px-8",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-title",
                                                                  {
                                                                    staticClass:
                                                                      "subtitle-2 py-1",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Neto"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "v-list-item-subtitle",
                                                                  {
                                                                    staticClass:
                                                                      "text-right font-weight-bold grey-700--text",
                                                                  },
                                                                  [
                                                                    (
                                                                      _vm.linesWithAmountsError ||
                                                                      []
                                                                    ).length ||
                                                                    !_vm.$v
                                                                      .documents
                                                                      .discount
                                                                      .maxAmount ||
                                                                    !_vm.$v
                                                                      .documents
                                                                      .discount
                                                                      .maxPercent
                                                                      ? [
                                                                          _vm._v(
                                                                            "-"
                                                                          ),
                                                                        ]
                                                                      : [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$fmt.currency(
                                                                                _vm.documentCurrency,
                                                                                _vm
                                                                                  .aggregations
                                                                                  .amount
                                                                              )
                                                                            )
                                                                          ),
                                                                        ],
                                                                  ],
                                                                  2
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            !_vm.exempt
                                                              ? [
                                                                  _vm
                                                                    .aggregations
                                                                    .vat_withheld
                                                                    ? _c(
                                                                        "v-list-item",
                                                                        {
                                                                          staticClass:
                                                                            "py-0 px-8",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-list-item-title",
                                                                            {
                                                                              staticClass:
                                                                                "subtitle-2 pt-1",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "IVA retenido"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "v-list-item-subtitle",
                                                                            {
                                                                              staticClass:
                                                                                "text-right font-weight-bold grey-700--text",
                                                                            },
                                                                            [
                                                                              (
                                                                                _vm.linesWithAmountsError ||
                                                                                []
                                                                              )
                                                                                .length ||
                                                                              !_vm
                                                                                .$v
                                                                                .documents
                                                                                .discount
                                                                                .maxAmount ||
                                                                              !_vm
                                                                                .$v
                                                                                .documents
                                                                                .discount
                                                                                .maxPercent
                                                                                ? [
                                                                                    _vm._v(
                                                                                      "-"
                                                                                    ),
                                                                                  ]
                                                                                : [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$fmt.currency(
                                                                                          _vm.documentCurrency,
                                                                                          _vm
                                                                                            .aggregations
                                                                                            .vat_withheld
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                  ],
                                                                            ],
                                                                            2
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _vm._e(),
                                                                  _c(
                                                                    "v-list-item",
                                                                    {
                                                                      staticClass:
                                                                        "py-0 px-8",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-list-item-title",
                                                                        {
                                                                          staticClass:
                                                                            "subtitle-2 py-1",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "IVA (" +
                                                                              _vm._s(
                                                                                _vm
                                                                                  .activeDocument
                                                                                  .tax
                                                                              ) +
                                                                              "%)"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "v-list-item-subtitle",
                                                                        {
                                                                          staticClass:
                                                                            "text-right font-weight-bold grey-700--text",
                                                                        },
                                                                        [
                                                                          (
                                                                            _vm.linesWithAmountsError ||
                                                                            []
                                                                          )
                                                                            .length ||
                                                                          !_vm
                                                                            .$v
                                                                            .documents
                                                                            .discount
                                                                            .maxAmount ||
                                                                          !_vm
                                                                            .$v
                                                                            .documents
                                                                            .discount
                                                                            .maxPercent
                                                                            ? [
                                                                                _vm._v(
                                                                                  "-"
                                                                                ),
                                                                              ]
                                                                            : [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$fmt.currency(
                                                                                      _vm.documentCurrency,
                                                                                      _vm
                                                                                        .aggregations
                                                                                        .taxes
                                                                                    )
                                                                                  )
                                                                                ),
                                                                              ],
                                                                        ],
                                                                        2
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                            _vm.currentIrsTax
                                                              .length &&
                                                            !_vm.aggregations
                                                              .vat_withheld
                                                              ? _c(
                                                                  "v-list-item",
                                                                  {
                                                                    staticClass:
                                                                      "py-0 px-8",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "subtitle-2 py-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Otros impuestos"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "v-list-item-subtitle",
                                                                      {
                                                                        staticClass:
                                                                          "text-right font-weight-bold grey-700--text",
                                                                      },
                                                                      [
                                                                        (
                                                                          _vm.linesWithAmountsError ||
                                                                          []
                                                                        ).length
                                                                          ? [
                                                                              _vm._v(
                                                                                "-"
                                                                              ),
                                                                            ]
                                                                          : [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.$fmt.currency(
                                                                                    _vm.documentCurrency,
                                                                                    _vm
                                                                                      .aggregations
                                                                                      .irs_tax
                                                                                  )
                                                                                )
                                                                              ),
                                                                            ],
                                                                      ],
                                                                      2
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        : _vm._e(),
                                                    ]
                                                  : _vm._e(),
                                                _c("v-divider", {
                                                  staticClass: "mx-8 my-1",
                                                }),
                                                _c(
                                                  "v-list-item",
                                                  { staticClass: "py-0 px-8" },
                                                  [
                                                    _c(
                                                      "v-list-item-title",
                                                      {
                                                        staticClass:
                                                          "subtitle-1 grey-700--text font-weight-bold py-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Total documento"
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-list-item-subtitle",
                                                      {
                                                        staticClass:
                                                          "text-right subtitle-1 grey-700--text font-weight-bold",
                                                      },
                                                      [
                                                        (
                                                          _vm.linesWithAmountsError ||
                                                          []
                                                        ).length
                                                          ? [_vm._v("-")]
                                                          : [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$fmt.currency(
                                                                    _vm.documentCurrency,
                                                                    _vm
                                                                      .aggregations
                                                                      .total
                                                                  )
                                                                )
                                                              ),
                                                            ],
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                [
                                                  "CL110",
                                                  "CL111",
                                                  "CL112",
                                                ].includes(
                                                  _vm.documents.document_type
                                                )
                                                  ? _c(
                                                      "v-list-item",
                                                      {
                                                        staticClass:
                                                          "py-0 px-8",
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          {
                                                            staticClass:
                                                              "subtitle-1 grey-700--text font-weight-bold py-1",
                                                          },
                                                          [_vm._v("Total CLP")]
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          {
                                                            staticClass:
                                                              "text-right subtitle-1 grey-700--text font-weight-bold",
                                                          },
                                                          [
                                                            (
                                                              _vm.linesWithAmountsError ||
                                                              []
                                                            ).length
                                                              ? [_vm._v("-")]
                                                              : [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$fmt.integer(
                                                                          _vm.convertAmounts(
                                                                            _vm
                                                                              .aggregations
                                                                              .total,
                                                                            _vm
                                                                              .exchange
                                                                              .rate
                                                                          )
                                                                        )
                                                                      ) +
                                                                      " "
                                                                  ),
                                                                ],
                                                          ],
                                                          2
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-expansion-panels",
                          {
                            staticClass: "mt-5",
                            model: {
                              value: _vm.panelReferences,
                              callback: function ($$v) {
                                _vm.panelReferences = $$v
                              },
                              expression: "panelReferences",
                            },
                          },
                          [
                            _c(
                              "v-expansion-panel",
                              [
                                _c(
                                  "v-expansion-panel-header",
                                  { staticClass: "px-5 py-8" },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        attrs: {
                                          "no-gutters": "",
                                          align: "center",
                                        },
                                      },
                                      [
                                        _c("v-col", { staticClass: "pa-0" }, [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    size: "18",
                                                    color: "grey-700",
                                                  },
                                                },
                                                [_vm._v("mdi-clipboard-file")]
                                              ),
                                              _vm._v("Referencias"),
                                              _c(
                                                "v-chip",
                                                {
                                                  staticClass:
                                                    "ml-3 pa-2 caption grey-700--text",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "grey-background",
                                                  },
                                                },
                                                [_vm._v("Opcional")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-expansion-panel-content",
                                  { staticClass: "px-7 pb-5 pt-0" },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "pa-0 mt-n2",
                                        attrs: { cols: "12" },
                                      },
                                      [
                                        _vm._l(
                                          _vm.documents.references,
                                          function (d, i) {
                                            return _c(
                                              "div",
                                              {
                                                key: i,
                                                staticClass: "mb-n7",
                                                attrs: { "no-gutters": "" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex justify-space-between ma-0 pa-0",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex-grow-1",
                                                      },
                                                      [
                                                        _c(
                                                          "v-row",
                                                          {
                                                            attrs: {
                                                              align: "center",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex pa-0 mr-2",
                                                                style: `margin-top: 0px; min-width:${
                                                                  [
                                                                    "CL61",
                                                                  ].includes(
                                                                    _vm
                                                                      .documents
                                                                      .document_type
                                                                  )
                                                                    ? 330
                                                                    : 250
                                                                }px`,
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "pa-0 pt-8 mx-2",
                                                                    staticStyle:
                                                                      {
                                                                        "min-width":
                                                                          "26px",
                                                                        "margin-top":
                                                                          "9px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-chip",
                                                                      {
                                                                        staticClass:
                                                                          "px-2",
                                                                        attrs: {
                                                                          id: "product-index",
                                                                          "text-color":
                                                                            "grey-900",
                                                                          color:
                                                                            "green-100",
                                                                          small:
                                                                            "",
                                                                          label:
                                                                            "",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            i +
                                                                              1
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                [
                                                                  "CL61",
                                                                ].includes(
                                                                  _vm.documents
                                                                    .document_type
                                                                )
                                                                  ? _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0 mx-2",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item",
                                                                          {
                                                                            staticClass:
                                                                              "pa-0",
                                                                            staticStyle:
                                                                              {
                                                                                width:
                                                                                  "43px !important",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-list-item-content",
                                                                              {
                                                                                staticClass:
                                                                                  "py-2",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-list-item-title",
                                                                                  {
                                                                                    staticClass:
                                                                                      "grey-500--text py-1",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Global"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _c(
                                                                                  "v-list-item-subtitle",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ml-1",
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-switch",
                                                                                      {
                                                                                        staticClass:
                                                                                          "ma-0",
                                                                                        staticStyle:
                                                                                          {
                                                                                            position:
                                                                                              "absolute",
                                                                                            top: "35px",
                                                                                          },
                                                                                        attrs:
                                                                                          {
                                                                                            color:
                                                                                              "green-500",
                                                                                            dense:
                                                                                              "",
                                                                                            "hide-details":
                                                                                              "",
                                                                                            ripple: false,
                                                                                          },
                                                                                        on: {
                                                                                          change:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              _vm.documents.references[
                                                                                                i
                                                                                              ].serial = 0
                                                                                            },
                                                                                        },
                                                                                        model:
                                                                                          {
                                                                                            value:
                                                                                              _vm
                                                                                                .documents
                                                                                                .references[
                                                                                                i
                                                                                              ]
                                                                                                .ind_global,
                                                                                            callback:
                                                                                              function (
                                                                                                $$v
                                                                                              ) {
                                                                                                _vm.$set(
                                                                                                  _vm
                                                                                                    .documents
                                                                                                    .references[
                                                                                                    i
                                                                                                  ],
                                                                                                  "ind_global",
                                                                                                  $$v
                                                                                                )
                                                                                              },
                                                                                            expression:
                                                                                              "documents.references[i].ind_global",
                                                                                          },
                                                                                      }
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e(),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "pa-0",
                                                                    staticStyle:
                                                                      {
                                                                        width:
                                                                          "240px !important",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-content",
                                                                          {
                                                                            staticClass:
                                                                              "py-2",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-list-item-title",
                                                                              {
                                                                                staticClass:
                                                                                  "grey-500--text py-1",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Tipo de documento"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "v-list-item-subtitle",
                                                                              [
                                                                                _c(
                                                                                  "v-autocomplete",
                                                                                  {
                                                                                    staticClass:
                                                                                      "group-ref",
                                                                                    attrs:
                                                                                      {
                                                                                        error:
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .references
                                                                                            .$each[
                                                                                            i
                                                                                          ]
                                                                                            .reference_type
                                                                                            .$error,
                                                                                        items:
                                                                                          _vm.backupReferencesList,
                                                                                        "item-value":
                                                                                          "id",
                                                                                        "item-text":
                                                                                          "name",
                                                                                        "item-disabled":
                                                                                          "customDisabled",
                                                                                        "menu-props":
                                                                                          {
                                                                                            overflowY: true,
                                                                                            transition:
                                                                                              "slide-y-transition",
                                                                                            maxWidth:
                                                                                              "500px",
                                                                                          },
                                                                                        height:
                                                                                          "40",
                                                                                        "single-line":
                                                                                          "",
                                                                                        outlined:
                                                                                          "",
                                                                                        dense:
                                                                                          "",
                                                                                        "hide-details":
                                                                                          "",
                                                                                        "append-icon":
                                                                                          "mdi-chevron-down",
                                                                                        placeholder:
                                                                                          "Selecciona un tipo de documento",
                                                                                      },
                                                                                    on: {
                                                                                      focus:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.documentTypeRef(
                                                                                            i
                                                                                          )
                                                                                        },
                                                                                      input:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          _vm.currentDocumentTypeRef =
                                                                                            _vm.documents.references[
                                                                                              i
                                                                                            ].reference_type
                                                                                        },
                                                                                      change:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          _vm.documents.references[
                                                                                            i
                                                                                          ].serial =
                                                                                            null
                                                                                        },
                                                                                    },
                                                                                    scopedSlots:
                                                                                      _vm._u(
                                                                                        [
                                                                                          {
                                                                                            key: "item",
                                                                                            fn: function (
                                                                                              data
                                                                                            ) {
                                                                                              return [
                                                                                                _c(
                                                                                                  "v-list-item-title",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "grey-500--text py-1",
                                                                                                    staticStyle:
                                                                                                      {
                                                                                                        "min-width":
                                                                                                          "93% !important",
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        data
                                                                                                          .item
                                                                                                          .name
                                                                                                      ) +
                                                                                                        " (" +
                                                                                                        _vm._s(
                                                                                                          data.item.id.replace(
                                                                                                            /^[A-Z]{2}/,
                                                                                                            ""
                                                                                                          )
                                                                                                        ) +
                                                                                                        ")"
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                              ]
                                                                                            },
                                                                                          },
                                                                                          {
                                                                                            key: "selection",
                                                                                            fn: function (
                                                                                              data
                                                                                            ) {
                                                                                              return [
                                                                                                _c(
                                                                                                  "v-list-item-title",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "grey-500--text py-1",
                                                                                                    staticStyle:
                                                                                                      {
                                                                                                        "min-width":
                                                                                                          "93% !important",
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        data
                                                                                                          .item
                                                                                                          .name
                                                                                                      ) +
                                                                                                        " (" +
                                                                                                        _vm._s(
                                                                                                          data.item.id.replace(
                                                                                                            /^[A-Z]{2}/,
                                                                                                            ""
                                                                                                          )
                                                                                                        ) +
                                                                                                        ")"
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                              ]
                                                                                            },
                                                                                          },
                                                                                        ],
                                                                                        null,
                                                                                        true
                                                                                      ),
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .references
                                                                                            .$each[
                                                                                            i
                                                                                          ]
                                                                                            .reference_type
                                                                                            .$model,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .$v
                                                                                                .documents
                                                                                                .references
                                                                                                .$each[
                                                                                                i
                                                                                              ]
                                                                                                .reference_type,
                                                                                              "$model",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "$v.documents.references.$each[i].reference_type.$model",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-0 mx-2",
                                                                attrs: {
                                                                  cols: "2",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item",
                                                                  {
                                                                    staticClass:
                                                                      "pa-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      {
                                                                        staticClass:
                                                                          "py-2",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          {
                                                                            class:
                                                                              [
                                                                                "grey-500--text py-1",
                                                                                {
                                                                                  "disabled-item":
                                                                                    _vm
                                                                                      .documents
                                                                                      .references[
                                                                                      i
                                                                                    ]
                                                                                      .ind_global,
                                                                                },
                                                                              ],
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "N° de documento"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "v-list-item-subtitle",
                                                                          [
                                                                            [
                                                                              "CL801",
                                                                              "CL802",
                                                                              "CL803",
                                                                              "CL804",
                                                                              "CL805",
                                                                              "CL806",
                                                                              "CL807",
                                                                              "CL808",
                                                                              "CL809",
                                                                              "CL810",
                                                                              "CL811",
                                                                              "CL812",
                                                                              "CL813",
                                                                              "CL814",
                                                                              "CL815",
                                                                            ].includes(
                                                                              _vm.currentDocumentTypeRef
                                                                            )
                                                                              ? _c(
                                                                                  "v-text-field",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        error:
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .references
                                                                                            .$each[
                                                                                            i
                                                                                          ]
                                                                                            .serial
                                                                                            .$error,
                                                                                        oninput:
                                                                                          "this.value=this.value.replace(/[^a-zA-Z0-9-_,. ]/g,'');",
                                                                                        maxlength:
                                                                                          "18",
                                                                                        height:
                                                                                          "36",
                                                                                        solo: "",
                                                                                        outlined:
                                                                                          "",
                                                                                        flat: "",
                                                                                        dense:
                                                                                          "",
                                                                                        "hide-details":
                                                                                          "",
                                                                                        disabled:
                                                                                          _vm
                                                                                            .documents
                                                                                            .references[
                                                                                            i
                                                                                          ]
                                                                                            .ind_global,
                                                                                      },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .references
                                                                                            .$each[
                                                                                            i
                                                                                          ]
                                                                                            .serial
                                                                                            .$model,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .$v
                                                                                                .documents
                                                                                                .references
                                                                                                .$each[
                                                                                                i
                                                                                              ]
                                                                                                .serial,
                                                                                              "$model",
                                                                                              typeof $$v ===
                                                                                                "string"
                                                                                                ? $$v.trim()
                                                                                                : $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "$v.documents.references.$each[i].serial.$model",
                                                                                      },
                                                                                  }
                                                                                )
                                                                              : _c(
                                                                                  "v-text-field",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        error:
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .references
                                                                                            .$each[
                                                                                            i
                                                                                          ]
                                                                                            .serial
                                                                                            .$error,
                                                                                        oninput:
                                                                                          "this.value=this.value.replace(/[^a-zA-Z0-9]/g,'');",
                                                                                        maxlength:
                                                                                          "18",
                                                                                        height:
                                                                                          "36",
                                                                                        solo: "",
                                                                                        outlined:
                                                                                          "",
                                                                                        flat: "",
                                                                                        dense:
                                                                                          "",
                                                                                        "hide-details":
                                                                                          "",
                                                                                        disabled:
                                                                                          _vm
                                                                                            .documents
                                                                                            .references[
                                                                                            i
                                                                                          ]
                                                                                            .ind_global,
                                                                                      },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .references
                                                                                            .$each[
                                                                                            i
                                                                                          ]
                                                                                            .serial
                                                                                            .$model,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .$v
                                                                                                .documents
                                                                                                .references
                                                                                                .$each[
                                                                                                i
                                                                                              ]
                                                                                                .serial,
                                                                                              "$model",
                                                                                              typeof $$v ===
                                                                                                "string"
                                                                                                ? $$v.trim()
                                                                                                : $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "$v.documents.references.$each[i].serial.$model",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-0 mx-2",
                                                                attrs: {
                                                                  cols: "2",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item",
                                                                  {
                                                                    staticClass:
                                                                      "pa-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      {
                                                                        staticClass:
                                                                          "py-2",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          {
                                                                            staticClass:
                                                                              "grey-500--text py-1",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Fecha"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "v-list-item-subtitle",
                                                                          [
                                                                            _c(
                                                                              "v-menu",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    "close-on-content-click": false,
                                                                                    top: "",
                                                                                    "offset-y":
                                                                                      "",
                                                                                    transition:
                                                                                      "slide-y-transition",
                                                                                    "max-width":
                                                                                      "290",
                                                                                  },
                                                                                scopedSlots:
                                                                                  _vm._u(
                                                                                    [
                                                                                      {
                                                                                        key: "activator",
                                                                                        fn: function ({
                                                                                          on,
                                                                                          attrs,
                                                                                        }) {
                                                                                          return [
                                                                                            _c(
                                                                                              "v-text-field",
                                                                                              _vm._g(
                                                                                                _vm._b(
                                                                                                  {
                                                                                                    attrs:
                                                                                                      {
                                                                                                        error:
                                                                                                          _vm
                                                                                                            .$v
                                                                                                            .documents
                                                                                                            .references
                                                                                                            .$each[
                                                                                                            i
                                                                                                          ]
                                                                                                            .date
                                                                                                            .$error,
                                                                                                        "append-icon":
                                                                                                          "mdi-calendar-blank",
                                                                                                        placeholder:
                                                                                                          "dd-mm-aaaa",
                                                                                                        readonly:
                                                                                                          "",
                                                                                                        height:
                                                                                                          "36",
                                                                                                        solo: "",
                                                                                                        outlined:
                                                                                                          "",
                                                                                                        flat: "",
                                                                                                        dense:
                                                                                                          "",
                                                                                                        "hide-details":
                                                                                                          "",
                                                                                                      },
                                                                                                    model:
                                                                                                      {
                                                                                                        value:
                                                                                                          _vm
                                                                                                            .$v
                                                                                                            .documents
                                                                                                            .references
                                                                                                            .$each[
                                                                                                            i
                                                                                                          ]
                                                                                                            .date
                                                                                                            .$model,
                                                                                                        callback:
                                                                                                          function (
                                                                                                            $$v
                                                                                                          ) {
                                                                                                            _vm.$set(
                                                                                                              _vm
                                                                                                                .$v
                                                                                                                .documents
                                                                                                                .references
                                                                                                                .$each[
                                                                                                                i
                                                                                                              ]
                                                                                                                .date,
                                                                                                              "$model",
                                                                                                              $$v
                                                                                                            )
                                                                                                          },
                                                                                                        expression:
                                                                                                          "$v.documents.references.$each[i].date.$model",
                                                                                                      },
                                                                                                  },
                                                                                                  "v-text-field",
                                                                                                  attrs,
                                                                                                  false
                                                                                                ),
                                                                                                on
                                                                                              )
                                                                                            ),
                                                                                          ]
                                                                                        },
                                                                                      },
                                                                                    ],
                                                                                    null,
                                                                                    true
                                                                                  ),
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .datePickerMenuDocumentsReferences[
                                                                                        i
                                                                                      ],
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm.datePickerMenuDocumentsReferences,
                                                                                          i,
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "datePickerMenuDocumentsReferences[i]",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-date-picker",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        "no-title":
                                                                                          "",
                                                                                        "first-day-of-week": 1,
                                                                                        type: "date",
                                                                                        locale:
                                                                                          "es",
                                                                                        width:
                                                                                          "290",
                                                                                        color:
                                                                                          "grey-900",
                                                                                      },
                                                                                    on: {
                                                                                      input:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          _vm.datePickerMenuDocumentsReferences[
                                                                                            i
                                                                                          ] = false
                                                                                        },
                                                                                    },
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .references
                                                                                            .$each[
                                                                                            i
                                                                                          ]
                                                                                            .date
                                                                                            .$model,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .$v
                                                                                                .documents
                                                                                                .references
                                                                                                .$each[
                                                                                                i
                                                                                              ]
                                                                                                .date,
                                                                                              "$model",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "$v.documents.references.$each[i].date.$model",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-row",
                                                                                      {
                                                                                        staticClass:
                                                                                          "pb-5 px-6",
                                                                                        attrs:
                                                                                          {
                                                                                            align:
                                                                                              "center",
                                                                                            justify:
                                                                                              "space-between",
                                                                                          },
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "v-btn",
                                                                                          {
                                                                                            staticClass:
                                                                                              "body-1",
                                                                                            attrs:
                                                                                              {
                                                                                                ripple: false,
                                                                                                text: "",
                                                                                                color:
                                                                                                  "grey-900",
                                                                                              },
                                                                                            on: {
                                                                                              click:
                                                                                                () => {
                                                                                                  _vm.$v.documents.references.$each[
                                                                                                    i
                                                                                                  ].date.$model =
                                                                                                    ""
                                                                                                  _vm.datePickerMenuDocumentsReferences[
                                                                                                    i
                                                                                                  ] = false
                                                                                                },
                                                                                            },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "Limpiar"
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                        _c(
                                                                                          "v-spacer"
                                                                                        ),
                                                                                        _c(
                                                                                          "v-btn",
                                                                                          {
                                                                                            attrs:
                                                                                              {
                                                                                                color:
                                                                                                  "grey-900",
                                                                                              },
                                                                                            on: {
                                                                                              click:
                                                                                                () => {
                                                                                                  _vm.$v.documents.references.$each[
                                                                                                    i
                                                                                                  ].date.$model =
                                                                                                    _vm.today
                                                                                                  _vm.datePickerMenuDocumentsReferences[
                                                                                                    i
                                                                                                  ] = false
                                                                                                },
                                                                                            },
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "Hoy"
                                                                                            ),
                                                                                          ]
                                                                                        ),
                                                                                      ],
                                                                                      1
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm.documentTypeForOverrideType[
                                                              _vm.documents
                                                                .document_type
                                                            ]?.includes(
                                                              _vm.documents
                                                                .references[i]
                                                                ?.reference_type
                                                            )
                                                              ? _c(
                                                                  "v-col",
                                                                  {
                                                                    staticClass:
                                                                      "pa-0 mx-2",
                                                                    attrs: {
                                                                      cols: 2,
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-content",
                                                                          {
                                                                            staticClass:
                                                                              "py-2",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-list-item-title",
                                                                              {
                                                                                staticClass:
                                                                                  "grey-500--text py-1",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Tipo de nota"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "v-list-item-subtitle",
                                                                              [
                                                                                _c(
                                                                                  "v-autocomplete",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        error:
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .references
                                                                                            .$each[
                                                                                            i
                                                                                          ]
                                                                                            .cod_ref
                                                                                            .$error,
                                                                                        items:
                                                                                          _vm.overrideType,
                                                                                        "item-value":
                                                                                          "id",
                                                                                        "item-text":
                                                                                          "name",
                                                                                        "menu-props":
                                                                                          {
                                                                                            overflowY: true,
                                                                                            transition:
                                                                                              "slide-y-transition",
                                                                                          },
                                                                                        height:
                                                                                          "36",
                                                                                        solo: "",
                                                                                        outlined:
                                                                                          "",
                                                                                        flat: "",
                                                                                        dense:
                                                                                          "",
                                                                                        "hide-details":
                                                                                          "",
                                                                                        "append-icon":
                                                                                          "mdi-chevron-down",
                                                                                      },
                                                                                    scopedSlots:
                                                                                      _vm._u(
                                                                                        [
                                                                                          {
                                                                                            key: "selection",
                                                                                            fn: function (
                                                                                              data
                                                                                            ) {
                                                                                              return [
                                                                                                _c(
                                                                                                  "v-list-item-title",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "grey-500--text py-1",
                                                                                                    staticStyle:
                                                                                                      {
                                                                                                        "min-width":
                                                                                                          "93% !important",
                                                                                                      },
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        data
                                                                                                          .item
                                                                                                          .name
                                                                                                      )
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                              ]
                                                                                            },
                                                                                          },
                                                                                        ],
                                                                                        null,
                                                                                        true
                                                                                      ),
                                                                                    model:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .references
                                                                                            .$each[
                                                                                            i
                                                                                          ]
                                                                                            .cod_ref
                                                                                            .$model,
                                                                                        callback:
                                                                                          function (
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .$v
                                                                                                .documents
                                                                                                .references
                                                                                                .$each[
                                                                                                i
                                                                                              ]
                                                                                                .cod_ref,
                                                                                              "$model",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                        expression:
                                                                                          "$v.documents.references.$each[i].cod_ref.$model",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            [
                                                              "CL56",
                                                              "CL61",
                                                            ].includes(
                                                              _vm.documents
                                                                .document_type
                                                            ) && i === 0
                                                              ? _c(
                                                                  "v-col",
                                                                  {
                                                                    staticClass:
                                                                      "pa-0 mx-2",
                                                                    attrs: {
                                                                      cols: "2",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item",
                                                                      {
                                                                        staticClass:
                                                                          "pa-0",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-content",
                                                                          {
                                                                            staticClass:
                                                                              "py-2",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "v-list-item-title",
                                                                              {
                                                                                staticClass:
                                                                                  "grey-500--text py-1",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "RUT otro contribuyente"
                                                                                ),
                                                                                _c(
                                                                                  "v-chip",
                                                                                  {
                                                                                    staticClass:
                                                                                      "ml-1 pa-2 caption grey-700--text",
                                                                                    attrs:
                                                                                      {
                                                                                        "x-small":
                                                                                          "",
                                                                                        color:
                                                                                          "grey-background",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Opcional"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _c(
                                                                              "v-list-item-subtitle",
                                                                              [
                                                                                _c(
                                                                                  "v-text-field",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        value:
                                                                                          _vm
                                                                                            .documents
                                                                                            .references[
                                                                                            i
                                                                                          ]
                                                                                            .other_tax_id,
                                                                                        placeholder:
                                                                                          "12.345.678-9",
                                                                                        maxlength:
                                                                                          "12",
                                                                                        height:
                                                                                          "36",
                                                                                        solo: "",
                                                                                        outlined:
                                                                                          "",
                                                                                        flat: "",
                                                                                        dense:
                                                                                          "",
                                                                                        "hide-details":
                                                                                          "",
                                                                                      },
                                                                                    on: {
                                                                                      input:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.onRutInput(
                                                                                            $event,
                                                                                            i
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  }
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "v-col",
                                                              {
                                                                staticClass:
                                                                  "pa-0 mx-2",
                                                                style: `${
                                                                  [
                                                                    "CL61",
                                                                  ].includes(
                                                                    _vm
                                                                      .documents
                                                                      .document_type
                                                                  )
                                                                    ? "min-width:330px; max-width:330px;"
                                                                    : ""
                                                                }`,
                                                                attrs: {
                                                                  cols: !_vm.documentTypeForOverrideType[
                                                                    _vm
                                                                      .documents
                                                                      .document_type
                                                                  ]?.includes(
                                                                    _vm
                                                                      .documents
                                                                      .references[
                                                                      i
                                                                    ]
                                                                      ?.reference_type
                                                                  )
                                                                    ? ""
                                                                    : "4",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item",
                                                                  {
                                                                    staticClass:
                                                                      "pa-0",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-content",
                                                                      {
                                                                        staticClass:
                                                                          "py-2",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-list-item-title",
                                                                          {
                                                                            staticClass:
                                                                              "grey-500--text py-1",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Descripción"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "v-list-item-subtitle",
                                                                          [
                                                                            _c(
                                                                              "v-text-field",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    error:
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .references
                                                                                        .$each[
                                                                                        i
                                                                                      ]
                                                                                        .description
                                                                                        .$error,
                                                                                    oninput:
                                                                                      "this.value=this.value.replace(/[^a-zA-Z0-9-_,. ]/g,'');",
                                                                                    maxlength:
                                                                                      "36",
                                                                                    height:
                                                                                      "36",
                                                                                    solo: "",
                                                                                    outlined:
                                                                                      "",
                                                                                    flat: "",
                                                                                    dense:
                                                                                      "",
                                                                                    "hide-details":
                                                                                      "",
                                                                                  },
                                                                                model:
                                                                                  {
                                                                                    value:
                                                                                      _vm
                                                                                        .$v
                                                                                        .documents
                                                                                        .references
                                                                                        .$each[
                                                                                        i
                                                                                      ]
                                                                                        .description
                                                                                        .$model,
                                                                                    callback:
                                                                                      function (
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .$v
                                                                                            .documents
                                                                                            .references
                                                                                            .$each[
                                                                                            i
                                                                                          ]
                                                                                            .description,
                                                                                          "$model",
                                                                                          typeof $$v ===
                                                                                            "string"
                                                                                            ? $$v.trim()
                                                                                            : $$v
                                                                                        )
                                                                                      },
                                                                                    expression:
                                                                                      "$v.documents.references.$each[i].description.$model",
                                                                                  },
                                                                              }
                                                                            ),
                                                                          ],
                                                                          1
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    i > 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-right ml-4 mt-6",
                                                            staticStyle: {
                                                              "max-width":
                                                                "40px",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  "min-width":
                                                                    "20",
                                                                  "max-width":
                                                                    "20",
                                                                  "min-height":
                                                                    "28",
                                                                  "max-height":
                                                                    "28",
                                                                  text: "",
                                                                  ripple: false,
                                                                  color:
                                                                    "grey-200",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.documents.references.splice(
                                                                        i,
                                                                        1
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      size: "24",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-delete"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                i !==
                                                (
                                                  (_vm.documents || {})
                                                    .references || []
                                                ).length -
                                                  1
                                                  ? _c("v-divider", {
                                                      class: `${
                                                        i === 0
                                                          ? "mt-5"
                                                          : "mt-5"
                                                      } mb-12`,
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        _c(
                                          "div",
                                          {
                                            class:
                                              (
                                                (_vm.documents || {})
                                                  .references || []
                                              ).length === 1
                                                ? "mt-10"
                                                : "mt-8",
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "font-weight-bold",
                                                attrs: {
                                                  text: "",
                                                  color: "grey-900",
                                                  ripple: false,
                                                },
                                                on: {
                                                  click:
                                                    _vm.addDocumentsReference,
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { left: "" } },
                                                  [
                                                    _vm._v(
                                                      "mdi-file-plus-outline"
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-medium body-1",
                                                  },
                                                  [_vm._v("Agregar referencia")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-card",
                          { staticClass: "mt-5", attrs: { flat: "" } },
                          [
                            _c(
                              "v-card-actions",
                              { staticClass: "py-4 px-5" },
                              [
                                _c("v-spacer"),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      to: {
                                        name: "DocumentsList",
                                        params: { ..._vm.$route.params },
                                      },
                                      outlined: "",
                                    },
                                  },
                                  [_vm._v("Cancelar")]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      outlined: "",
                                      loading: _vm.loadingPreviewPDF,
                                      disabled: _vm.$v.documents.$invalid,
                                    },
                                    on: { click: _vm.handlePreviewPDFModal },
                                  },
                                  [_vm._v("Previsualizar PDF")]
                                ),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "grey-900",
                                      dark: "",
                                      loading: _vm.loadingSave,
                                    },
                                    on: { click: _vm.handlePreviewPDF },
                                  },
                                  [_vm._v("Continuar")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
      _c(
        "v-dialog",
        {
          attrs: {
            width: "700",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "overlay",
          },
          model: {
            value: _vm.dialogReviewPDF,
            callback: function ($$v) {
              _vm.dialogReviewPDF = $$v
            },
            expression: "dialogReviewPDF",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "transparent",
                  attrs: { flat: "", height: "46" },
                },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticClass:
                        "px-5 subtitle-2 grey-700--text font-weight-semibold",
                    },
                    [_vm._v(_vm._s(_vm.previewPDFTitle))]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "mr-4",
                          attrs: { align: "center", justify: "center" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                "retain-focus-on-click": "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.dialogReviewPDF = false
                                },
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                { attrs: { color: "grey-500", size: "20" } },
                                [_vm._v("mdi-close")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c("render-pdf", {
                attrs: {
                  basicRender: true,
                  loaderRender: _vm.loaderRender,
                  renderUrl: _vm.renderUrlPDF,
                  flat: true,
                  showToolbar: false,
                  showTemplateSelector: false,
                  showFooter: false,
                },
              }),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogReviewPDF = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: {
                        click: function ($event) {
                          _vm.dialogReviewPDF = false
                          _vm.confirmContinueModal = true
                        },
                      },
                    },
                    [_vm._v("Continuar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "495",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.successDocumentModal,
            callback: function ($$v) {
              _vm.successDocumentModal = $$v
            },
            expression: "successDocumentModal",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Generación exitosa")]
                      ),
                      _c("v-spacer"),
                      _c("v-toolbar-items"),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-4", attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-img", {
                            attrs: {
                              height: 120,
                              src: require(`@/assets/backgrounds/modal-document-create-success.svg`),
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-col", { staticClass: "pr-4 pl-8 body-1" }, [
                        _vm._v(" Generación exitosa del documento "),
                        _c("span", { staticClass: "font-weight-medium" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("nameDocumentsType")(_vm.newDocument.type)
                            ) +
                              " con folio " +
                              _vm._s(_vm.newDocument.number)
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "green-500" },
                      on: {
                        click: function ($event) {
                          return _vm.clear()
                        },
                      },
                    },
                    [_vm._v("Crear nuevo")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        to: {
                          name: "DocumentsList",
                          query: { ref: "initial" },
                          params: { ..._vm.$route.params },
                        },
                        outlined: "",
                      },
                    },
                    [_vm._v("Ver todos")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push({
                            name: "DocumentsRetrieve",
                            params: {
                              id: _vm.newDocument.id,
                              ..._vm.$route.params,
                            },
                          })
                        },
                      },
                    },
                    [_vm._v("Ver documento")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "595",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.confirmContinueModal,
            callback: function ($$v) {
              _vm.confirmContinueModal = $$v
            },
            expression: "confirmContinueModal",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Confirmar emisión del documento")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.confirmContinueModal = false),
                                        (_vm.confirmDocument = "")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-4", attrs: { align: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "4" } },
                        [
                          _c("v-img", {
                            attrs: {
                              height: 150,
                              src: require(`@/assets/backgrounds/modal-document-confirm.svg`),
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 pl-8 body-1" },
                        [
                          _c(
                            "span",
                            { staticClass: "d-block font-weight-semibold" },
                            [
                              _vm._v(
                                "¿Estás seguro que deseas emitir este documento?"
                              ),
                            ]
                          ),
                          _c("span", { staticClass: "d-block mt-4 mb-3" }, [
                            _vm._v(
                              "Si confirmas, será enviado al SII y tendrá plena validez tributaria."
                            ),
                          ]),
                          _c("span", { staticClass: "d-block mt-4 mb-3" }, [
                            _vm._v("Escribe "),
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("“confirmar”"),
                            ]),
                            _vm._v(" para continuar."),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              "single-line": "",
                              maxlength: "9",
                              dense: "",
                              "hide-details": "",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                _vm.confirmDocument.toLowerCase() !==
                                "confirmar"
                                  ? null
                                  : _vm.createDocuments()
                              },
                            },
                            model: {
                              value: _vm.confirmDocument,
                              callback: function ($$v) {
                                _vm.confirmDocument = $$v
                              },
                              expression: "confirmDocument",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          ;(_vm.confirmContinueModal = false),
                            (_vm.confirmDocument = "")
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loadingSave,
                        color: "grey-900",
                        disabled:
                          _vm.confirmDocument.toLowerCase() !== "confirmar",
                      },
                      on: { click: _vm.createDocuments },
                    },
                    [_vm._v("Continuar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }